import * as u from "ably";
var At = /* @__PURE__ */ ((n) => (n.Trace = "trace", n.Debug = "debug", n.Info = "info", n.Warn = "warn", n.Error = "error", n.Silent = "silent", n))(At || {});
const ir = (n, e, t) => {
  const r = t ? `, context: ${JSON.stringify(t)}` : "", i = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${e.valueOf().toUpperCase()} ably-chat: ${n}${r}`;
  switch (e) {
    case "trace":
    case "debug": {
      console.log(i);
      break;
    }
    case "info": {
      console.info(i);
      break;
    }
    case "warn": {
      console.warn(i);
      break;
    }
    case "error": {
      console.error(i);
      break;
    }
  }
}, ar = (n) => {
  const e = n.logHandler ?? ir;
  return new De(e, n.logLevel);
}, bt = /* @__PURE__ */ new Map([
  [
    "trace",
    0
    /* Trace */
  ],
  [
    "debug",
    1
    /* Debug */
  ],
  [
    "info",
    2
    /* Info */
  ],
  [
    "warn",
    3
    /* Warn */
  ],
  [
    "error",
    4
    /* Error */
  ],
  [
    "silent",
    5
    /* Silent */
  ]
]);
class De {
  constructor(e, t, r) {
    this._handler = e, this._context = r;
    const i = bt.get(t);
    if (i === void 0)
      throw new u.ErrorInfo(`Invalid log level: ${t}`, 5e4, 500);
    this._levelNumber = i;
  }
  trace(e, t) {
    this._write(e, "trace", 0, t);
  }
  debug(e, t) {
    this._write(e, "debug", 1, t);
  }
  info(e, t) {
    this._write(e, "info", 2, t);
  }
  warn(e, t) {
    this._write(e, "warn", 3, t);
  }
  error(e, t) {
    this._write(e, "error", 4, t);
  }
  withContext(e) {
    const t = [...bt.entries()].find(([, r]) => r === this._levelNumber)?.[0] ?? "error";
    return new De(this._handler, t, this._mergeContext(e));
  }
  _write(e, t, r, i) {
    r >= this._levelNumber && this._handler(e, t, this._mergeContext(i));
  }
  _mergeContext(e) {
    return this._context ? e ? { ...this._context, ...e } : this._context : e ?? void 0;
  }
}
const or = {
  logLevel: At.Error
}, cr = (n) => (n = n ?? {}, {
  ...n,
  logLevel: n.logLevel ?? or.logLevel
});
function L(n, e, t) {
  if ((Array.isArray(e) || typeof e == "string") && t)
    return n.on(e, t), () => {
      n.off(t);
    };
  if (typeof e == "function")
    return n.on(e), () => {
      n.off(e);
    };
  throw new TypeError("Invalid arguments passed to on()");
}
function hr(n, e, t) {
  if (t)
    return n.once(e, t), () => {
      n.off(t);
    };
  throw new TypeError("Invalid arguments passed to once()");
}
function F(n, e, t) {
  if ((Array.isArray(e) || typeof e == "string") && t) {
    const r = n.subscribe(e, t);
    return () => {
      r.then(() => {
        n.unsubscribe(t);
      }).catch((i) => {
        console.error("Error subscribing to events:", i);
      });
    };
  } else if (typeof e == "function") {
    const r = n.subscribe(e);
    return () => {
      r.then(() => {
        n.unsubscribe(e);
      }).catch((i) => {
        console.error("Error subscribing to events:", i);
      });
    };
  } else
    throw new TypeError("Invalid arguments passed to subscribe()");
}
const lr = u.Realtime.EventEmitter;
class A extends lr {
}
const v = (n) => (...e) => n(...e), N = (n) => {
  const e = n, t = Object.values(e.events).flat().length + e.any.length + Object.values(e.eventsOnce).flat().length + e.anyOnce.length;
  return t ? t > 0 : !1;
};
var ur = /* @__PURE__ */ ((n) => (n.Initialized = "initialized", n.Connecting = "connecting", n.Connected = "connected", n.Disconnected = "disconnected", n.Suspended = "suspended", n.Failed = "failed", n))(ur || {});
class gr {
  /**
   * Constructs a new `DefaultConnection` instance.
   * @param ably The Ably Realtime client.
   * @param logger The logger to use.
   */
  constructor(e, t) {
    this._status = "initialized", this._emitter = new A(), this._logger = t, this._status = this._mapAblyStatusToChat(e.connection.state), this._error = e.connection.errorReason;
    const r = (i) => {
      const c = this._mapAblyStatusToChat(i.current);
      if (c === this._status)
        return;
      const l = {
        current: c,
        previous: this._status,
        error: i.reason,
        retryIn: i.retryIn
      };
      this._applyStatusChange(l);
    };
    this._clearAblyConnectionListener = L(e.connection, r);
  }
  /**
   * @inheritdoc
   */
  get status() {
    return this._status;
  }
  /**
   * @inheritdoc
   */
  get error() {
    return this._error;
  }
  /**
   * @inheritdoc
   */
  onStatusChange(e) {
    const t = v(e);
    return this._emitter.on(t), {
      off: () => {
        this._emitter.off(t);
      }
    };
  }
  /**
   * @inheritdoc
   */
  dispose() {
    this._logger.trace("DefaultConnection.dispose();"), this._clearAblyConnectionListener(), this._emitter.off();
  }
  /**
   * Checks if there are any listeners registered on the connection.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
  _applyStatusChange(e) {
    this._status = e.current, this._error = e.error, this._logger.info("Connection state changed", e), this._emitter.emit(e.current, e);
  }
  _mapAblyStatusToChat(e) {
    switch (e) {
      case "closing":
      case "closed":
        return "failed";
      default:
        return e;
    }
  }
}
const Et = () => Math.random().toString(36).slice(2);
var wt = Object.prototype.hasOwnProperty;
function St(n, e, t) {
  for (t of n.keys())
    if (Y(t, e)) return t;
}
function Y(n, e) {
  var t, r, i;
  if (n === e) return !0;
  if (n && e && (t = n.constructor) === e.constructor) {
    if (t === Date) return n.getTime() === e.getTime();
    if (t === RegExp) return n.toString() === e.toString();
    if (t === Array) {
      if ((r = n.length) === e.length)
        for (; r-- && Y(n[r], e[r]); ) ;
      return r === -1;
    }
    if (t === Set) {
      if (n.size !== e.size)
        return !1;
      for (r of n)
        if (i = r, i && typeof i == "object" && (i = St(e, i), !i) || !e.has(i)) return !1;
      return !0;
    }
    if (t === Map) {
      if (n.size !== e.size)
        return !1;
      for (r of n)
        if (i = r[0], i && typeof i == "object" && (i = St(e, i), !i) || !Y(r[1], e.get(i)))
          return !1;
      return !0;
    }
    if (t === ArrayBuffer)
      n = new Uint8Array(n), e = new Uint8Array(e);
    else if (t === DataView) {
      if ((r = n.byteLength) === e.byteLength)
        for (; r-- && n.getInt8(r) === e.getInt8(r); ) ;
      return r === -1;
    }
    if (ArrayBuffer.isView(n)) {
      if ((r = n.byteLength) === e.byteLength)
        for (; r-- && n[r] === e[r]; ) ;
      return r === -1;
    }
    if (!t || typeof n == "object") {
      r = 0;
      for (t in n)
        if (wt.call(n, t) && ++r && !wt.call(e, t) || !(t in e) || !Y(n[t], e[t])) return !1;
      return Object.keys(e).length === r;
    }
  }
  return n !== n && e !== e;
}
var P = /* @__PURE__ */ ((n) => (n.Created = "message.created", n.Updated = "message.updated", n.Deleted = "message.deleted", n))(P || {}), Ct = /* @__PURE__ */ ((n) => (n.ChatMessage = "chat.message", n))(Ct || {}), Ot = /* @__PURE__ */ ((n) => (n.Occupancy = "[meta]occupancy", n))(Ot || {}), R = /* @__PURE__ */ ((n) => (n.MessageCreate = "message.create", n.MessageUpdate = "message.update", n.MessageDelete = "message.delete", n.MessageAnnotationSummary = "message.summary", n.MessageMetaOccupancy = "meta.occupancy", n))(R || {}), dr = /* @__PURE__ */ ((n) => (n.Enter = "enter", n.Leave = "leave", n.Update = "update", n.Present = "present", n))(dr || {}), T = /* @__PURE__ */ ((n) => (n.Started = "typing.started", n.Stopped = "typing.stopped", n))(T || {}), k = /* @__PURE__ */ ((n) => (n.SetChanged = "typing.set.changed", n))(k || {}), Ee = /* @__PURE__ */ ((n) => (n.Reaction = "roomReaction", n))(Ee || {}), Ce = /* @__PURE__ */ ((n) => (n.Reaction = "reaction", n))(Ce || {}), z = /* @__PURE__ */ ((n) => (n.Unique = "unique", n.Distinct = "distinct", n.Multiple = "multiple", n))(z || {}), he = /* @__PURE__ */ ((n) => (n.Unique = "reaction:unique.v1", n.Distinct = "reaction:distinct.v1", n.Multiple = "reaction:multiple.v1", n))(he || {});
const _r = {
  "reaction:unique.v1": "unique",
  "reaction:distinct.v1": "distinct",
  "reaction:multiple.v1": "multiple"
  /* Multiple */
};
var M = /* @__PURE__ */ ((n) => (n.Create = "reaction.create", n.Delete = "reaction.delete", n.Summary = "reaction.summary", n))(M || {}), Oe = /* @__PURE__ */ ((n) => (n.Updated = "occupancy.updated", n))(Oe || {}), J = /* @__PURE__ */ ((n) => (n.Discontinuity = "room.discontinuity", n))(J || {}), ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pr(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var X = { exports: {} };
X.exports;
var vt;
function fr() {
  return vt || (vt = 1, function(n, e) {
    var t = 200, r = "__lodash_hash_undefined__", i = 9007199254740991, c = "[object Arguments]", l = "[object Array]", d = "[object Boolean]", g = "[object Date]", m = "[object Error]", _ = "[object Function]", S = "[object GeneratorFunction]", Z = "[object Map]", Le = "[object Number]", _e = "[object Object]", Pe = "[object Promise]", Ne = "[object RegExp]", ee = "[object Set]", Ue = "[object String]", qe = "[object Symbol]", pe = "[object WeakMap]", je = "[object ArrayBuffer]", te = "[object DataView]", ke = "[object Float32Array]", ze = "[object Float64Array]", Be = "[object Int8Array]", Fe = "[object Int16Array]", $e = "[object Int32Array]", He = "[object Uint8Array]", Ve = "[object Uint8ClampedArray]", Ge = "[object Uint16Array]", We = "[object Uint32Array]", Nt = /[\\^$.*+?()[\]{}|]/g, Ut = /\w*$/, qt = /^\[object .+?Constructor\]$/, jt = /^(?:0|[1-9]\d*)$/, p = {};
    p[c] = p[l] = p[je] = p[te] = p[d] = p[g] = p[ke] = p[ze] = p[Be] = p[Fe] = p[$e] = p[Z] = p[Le] = p[_e] = p[Ne] = p[ee] = p[Ue] = p[qe] = p[He] = p[Ve] = p[Ge] = p[We] = !0, p[m] = p[_] = p[pe] = !1;
    var kt = typeof ce == "object" && ce && ce.Object === Object && ce, zt = typeof self == "object" && self && self.Object === Object && self, E = kt || zt || Function("return this")(), Ke = e && !e.nodeType && e, Qe = Ke && !0 && n && !n.nodeType && n, Bt = Qe && Qe.exports === Ke;
    function Ft(s, a) {
      return s.set(a[0], a[1]), s;
    }
    function $t(s, a) {
      return s.add(a), s;
    }
    function Ht(s, a) {
      for (var o = -1, h = s ? s.length : 0; ++o < h && a(s[o], o, s) !== !1; )
        ;
      return s;
    }
    function Vt(s, a) {
      for (var o = -1, h = a.length, y = s.length; ++o < h; )
        s[y + o] = a[o];
      return s;
    }
    function Je(s, a, o, h) {
      for (var y = -1, b = s ? s.length : 0; ++y < b; )
        o = a(o, s[y], y, s);
      return o;
    }
    function Gt(s, a) {
      for (var o = -1, h = Array(s); ++o < s; )
        h[o] = a(o);
      return h;
    }
    function Wt(s, a) {
      return s?.[a];
    }
    function Xe(s) {
      var a = !1;
      if (s != null && typeof s.toString != "function")
        try {
          a = !!(s + "");
        } catch {
        }
      return a;
    }
    function Ye(s) {
      var a = -1, o = Array(s.size);
      return s.forEach(function(h, y) {
        o[++a] = [y, h];
      }), o;
    }
    function fe(s, a) {
      return function(o) {
        return s(a(o));
      };
    }
    function Ze(s) {
      var a = -1, o = Array(s.size);
      return s.forEach(function(h) {
        o[++a] = h;
      }), o;
    }
    var Kt = Array.prototype, Qt = Function.prototype, se = Object.prototype, me = E["__core-js_shared__"], et = function() {
      var s = /[^.]+$/.exec(me && me.keys && me.keys.IE_PROTO || "");
      return s ? "Symbol(src)_1." + s : "";
    }(), tt = Qt.toString, I = se.hasOwnProperty, re = se.toString, Jt = RegExp(
      "^" + tt.call(I).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), st = Bt ? E.Buffer : void 0, rt = E.Symbol, nt = E.Uint8Array, Xt = fe(Object.getPrototypeOf, Object), Yt = Object.create, Zt = se.propertyIsEnumerable, es = Kt.splice, it = Object.getOwnPropertySymbols, ts = st ? st.isBuffer : void 0, ss = fe(Object.keys, Object), ye = V(E, "DataView"), K = V(E, "Map"), be = V(E, "Promise"), we = V(E, "Set"), Se = V(E, "WeakMap"), Q = V(Object, "create"), rs = j(ye), ns = j(K), is = j(be), as = j(we), os = j(Se), at = rt ? rt.prototype : void 0, ot = at ? at.valueOf : void 0;
    function U(s) {
      var a = -1, o = s ? s.length : 0;
      for (this.clear(); ++a < o; ) {
        var h = s[a];
        this.set(h[0], h[1]);
      }
    }
    function cs() {
      this.__data__ = Q ? Q(null) : {};
    }
    function hs(s) {
      return this.has(s) && delete this.__data__[s];
    }
    function ls(s) {
      var a = this.__data__;
      if (Q) {
        var o = a[s];
        return o === r ? void 0 : o;
      }
      return I.call(a, s) ? a[s] : void 0;
    }
    function us(s) {
      var a = this.__data__;
      return Q ? a[s] !== void 0 : I.call(a, s);
    }
    function gs(s, a) {
      var o = this.__data__;
      return o[s] = Q && a === void 0 ? r : a, this;
    }
    U.prototype.clear = cs, U.prototype.delete = hs, U.prototype.get = ls, U.prototype.has = us, U.prototype.set = gs;
    function C(s) {
      var a = -1, o = s ? s.length : 0;
      for (this.clear(); ++a < o; ) {
        var h = s[a];
        this.set(h[0], h[1]);
      }
    }
    function ds() {
      this.__data__ = [];
    }
    function _s(s) {
      var a = this.__data__, o = ne(a, s);
      if (o < 0)
        return !1;
      var h = a.length - 1;
      return o == h ? a.pop() : es.call(a, o, 1), !0;
    }
    function ps(s) {
      var a = this.__data__, o = ne(a, s);
      return o < 0 ? void 0 : a[o][1];
    }
    function fs(s) {
      return ne(this.__data__, s) > -1;
    }
    function ms(s, a) {
      var o = this.__data__, h = ne(o, s);
      return h < 0 ? o.push([s, a]) : o[h][1] = a, this;
    }
    C.prototype.clear = ds, C.prototype.delete = _s, C.prototype.get = ps, C.prototype.has = fs, C.prototype.set = ms;
    function $(s) {
      var a = -1, o = s ? s.length : 0;
      for (this.clear(); ++a < o; ) {
        var h = s[a];
        this.set(h[0], h[1]);
      }
    }
    function ys() {
      this.__data__ = {
        hash: new U(),
        map: new (K || C)(),
        string: new U()
      };
    }
    function bs(s) {
      return ie(this, s).delete(s);
    }
    function ws(s) {
      return ie(this, s).get(s);
    }
    function Ss(s) {
      return ie(this, s).has(s);
    }
    function vs(s, a) {
      return ie(this, s).set(s, a), this;
    }
    $.prototype.clear = ys, $.prototype.delete = bs, $.prototype.get = ws, $.prototype.has = Ss, $.prototype.set = vs;
    function H(s) {
      this.__data__ = new C(s);
    }
    function Rs() {
      this.__data__ = new C();
    }
    function Ts(s) {
      return this.__data__.delete(s);
    }
    function Ms(s) {
      return this.__data__.get(s);
    }
    function As(s) {
      return this.__data__.has(s);
    }
    function Es(s, a) {
      var o = this.__data__;
      if (o instanceof C) {
        var h = o.__data__;
        if (!K || h.length < t - 1)
          return h.push([s, a]), this;
        o = this.__data__ = new $(h);
      }
      return o.set(s, a), this;
    }
    H.prototype.clear = Rs, H.prototype.delete = Ts, H.prototype.get = Ms, H.prototype.has = As, H.prototype.set = Es;
    function Cs(s, a) {
      var o = Te(s) || Ys(s) ? Gt(s.length, String) : [], h = o.length, y = !!h;
      for (var b in s)
        I.call(s, b) && !(y && (b == "length" || Ks(b, h))) && o.push(b);
      return o;
    }
    function ct(s, a, o) {
      var h = s[a];
      (!(I.call(s, a) && gt(h, o)) || o === void 0 && !(a in s)) && (s[a] = o);
    }
    function ne(s, a) {
      for (var o = s.length; o--; )
        if (gt(s[o][0], a))
          return o;
      return -1;
    }
    function Os(s, a) {
      return s && ht(a, Me(a), s);
    }
    function ve(s, a, o, h, y, b, O) {
      var w;
      if (h && (w = b ? h(s, y, b, O) : h(s)), w !== void 0)
        return w;
      if (!ae(s))
        return s;
      var pt = Te(s);
      if (pt) {
        if (w = Vs(s), !a)
          return Fs(s, w);
      } else {
        var G = q(s), ft = G == _ || G == S;
        if (er(s))
          return Ns(s, a);
        if (G == _e || G == c || ft && !b) {
          if (Xe(s))
            return b ? s : {};
          if (w = Gs(ft ? {} : s), !a)
            return $s(s, Os(w, s));
        } else {
          if (!p[G])
            return b ? s : {};
          w = Ws(s, G, ve, a);
        }
      }
      O || (O = new H());
      var mt = O.get(s);
      if (mt)
        return mt;
      if (O.set(s, w), !pt)
        var yt = o ? Hs(s) : Me(s);
      return Ht(yt || s, function(Ae, oe) {
        yt && (oe = Ae, Ae = s[oe]), ct(w, oe, ve(Ae, a, o, h, oe, s, O));
      }), w;
    }
    function Is(s) {
      return ae(s) ? Yt(s) : {};
    }
    function Ds(s, a, o) {
      var h = a(s);
      return Te(s) ? h : Vt(h, o(s));
    }
    function xs(s) {
      return re.call(s);
    }
    function Ls(s) {
      if (!ae(s) || Js(s))
        return !1;
      var a = _t(s) || Xe(s) ? Jt : qt;
      return a.test(j(s));
    }
    function Ps(s) {
      if (!ut(s))
        return ss(s);
      var a = [];
      for (var o in Object(s))
        I.call(s, o) && o != "constructor" && a.push(o);
      return a;
    }
    function Ns(s, a) {
      if (a)
        return s.slice();
      var o = new s.constructor(s.length);
      return s.copy(o), o;
    }
    function Re(s) {
      var a = new s.constructor(s.byteLength);
      return new nt(a).set(new nt(s)), a;
    }
    function Us(s, a) {
      var o = a ? Re(s.buffer) : s.buffer;
      return new s.constructor(o, s.byteOffset, s.byteLength);
    }
    function qs(s, a, o) {
      var h = a ? o(Ye(s), !0) : Ye(s);
      return Je(h, Ft, new s.constructor());
    }
    function js(s) {
      var a = new s.constructor(s.source, Ut.exec(s));
      return a.lastIndex = s.lastIndex, a;
    }
    function ks(s, a, o) {
      var h = a ? o(Ze(s), !0) : Ze(s);
      return Je(h, $t, new s.constructor());
    }
    function zs(s) {
      return ot ? Object(ot.call(s)) : {};
    }
    function Bs(s, a) {
      var o = a ? Re(s.buffer) : s.buffer;
      return new s.constructor(o, s.byteOffset, s.length);
    }
    function Fs(s, a) {
      var o = -1, h = s.length;
      for (a || (a = Array(h)); ++o < h; )
        a[o] = s[o];
      return a;
    }
    function ht(s, a, o, h) {
      o || (o = {});
      for (var y = -1, b = a.length; ++y < b; ) {
        var O = a[y], w = void 0;
        ct(o, O, w === void 0 ? s[O] : w);
      }
      return o;
    }
    function $s(s, a) {
      return ht(s, lt(s), a);
    }
    function Hs(s) {
      return Ds(s, Me, lt);
    }
    function ie(s, a) {
      var o = s.__data__;
      return Qs(a) ? o[typeof a == "string" ? "string" : "hash"] : o.map;
    }
    function V(s, a) {
      var o = Wt(s, a);
      return Ls(o) ? o : void 0;
    }
    var lt = it ? fe(it, Object) : rr, q = xs;
    (ye && q(new ye(new ArrayBuffer(1))) != te || K && q(new K()) != Z || be && q(be.resolve()) != Pe || we && q(new we()) != ee || Se && q(new Se()) != pe) && (q = function(s) {
      var a = re.call(s), o = a == _e ? s.constructor : void 0, h = o ? j(o) : void 0;
      if (h)
        switch (h) {
          case rs:
            return te;
          case ns:
            return Z;
          case is:
            return Pe;
          case as:
            return ee;
          case os:
            return pe;
        }
      return a;
    });
    function Vs(s) {
      var a = s.length, o = s.constructor(a);
      return a && typeof s[0] == "string" && I.call(s, "index") && (o.index = s.index, o.input = s.input), o;
    }
    function Gs(s) {
      return typeof s.constructor == "function" && !ut(s) ? Is(Xt(s)) : {};
    }
    function Ws(s, a, o, h) {
      var y = s.constructor;
      switch (a) {
        case je:
          return Re(s);
        case d:
        case g:
          return new y(+s);
        case te:
          return Us(s, h);
        case ke:
        case ze:
        case Be:
        case Fe:
        case $e:
        case He:
        case Ve:
        case Ge:
        case We:
          return Bs(s, h);
        case Z:
          return qs(s, h, o);
        case Le:
        case Ue:
          return new y(s);
        case Ne:
          return js(s);
        case ee:
          return ks(s, h, o);
        case qe:
          return zs(s);
      }
    }
    function Ks(s, a) {
      return a = a ?? i, !!a && (typeof s == "number" || jt.test(s)) && s > -1 && s % 1 == 0 && s < a;
    }
    function Qs(s) {
      var a = typeof s;
      return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? s !== "__proto__" : s === null;
    }
    function Js(s) {
      return !!et && et in s;
    }
    function ut(s) {
      var a = s && s.constructor, o = typeof a == "function" && a.prototype || se;
      return s === o;
    }
    function j(s) {
      if (s != null) {
        try {
          return tt.call(s);
        } catch {
        }
        try {
          return s + "";
        } catch {
        }
      }
      return "";
    }
    function Xs(s) {
      return ve(s, !0, !0);
    }
    function gt(s, a) {
      return s === a || s !== s && a !== a;
    }
    function Ys(s) {
      return Zs(s) && I.call(s, "callee") && (!Zt.call(s, "callee") || re.call(s) == c);
    }
    var Te = Array.isArray;
    function dt(s) {
      return s != null && tr(s.length) && !_t(s);
    }
    function Zs(s) {
      return sr(s) && dt(s);
    }
    var er = ts || nr;
    function _t(s) {
      var a = ae(s) ? re.call(s) : "";
      return a == _ || a == S;
    }
    function tr(s) {
      return typeof s == "number" && s > -1 && s % 1 == 0 && s <= i;
    }
    function ae(s) {
      var a = typeof s;
      return !!s && (a == "object" || a == "function");
    }
    function sr(s) {
      return !!s && typeof s == "object";
    }
    function Me(s) {
      return dt(s) ? Cs(s) : Ps(s);
    }
    function rr() {
      return [];
    }
    function nr() {
      return !1;
    }
    n.exports = Xs;
  }(X, X.exports)), X.exports;
}
var mr = fr();
const D = /* @__PURE__ */ pr(mr);
class x {
  constructor({
    serial: e,
    clientId: t,
    text: r,
    metadata: i,
    headers: c,
    action: l,
    version: d,
    timestamp: g,
    reactions: m
  }) {
    this.serial = e, this.clientId = t, this.text = r, this.metadata = i, this.headers = c, this.action = l, this.version = d, this.timestamp = g, this.reactions = m, Object.freeze(this.version), Object.freeze(this.reactions), Object.freeze(this.reactions.multiple), Object.freeze(this.reactions.distinct), Object.freeze(this.reactions.unique), Object.freeze(this);
  }
  get isUpdated() {
    return this.action === R.MessageUpdate;
  }
  get isDeleted() {
    return this.action === R.MessageDelete;
  }
  get updatedBy() {
    return this.isUpdated ? this.version.clientId : void 0;
  }
  get deletedBy() {
    return this.isDeleted ? this.version.clientId : void 0;
  }
  get updatedAt() {
    return this.isUpdated ? this.version.timestamp : void 0;
  }
  get deletedAt() {
    return this.isDeleted ? this.version.timestamp : void 0;
  }
  isOlderVersionOf(e) {
    return this._compareVersions(
      this,
      e,
      (t, r) => t.serial < r.serial
    );
  }
  isNewerVersionOf(e) {
    return this._compareVersions(
      this,
      e,
      (t, r) => t.serial > r.serial
    );
  }
  isSameVersionAs(e) {
    return this._compareVersions(
      this,
      e,
      (t, r) => t.serial === r.serial
    );
  }
  _isNewerOrSameVersionOf(e) {
    return this._compareVersions(
      this,
      e,
      (t, r) => t.serial >= r.serial
    );
  }
  before(e) {
    return this.serial < e.serial;
  }
  after(e) {
    return this.serial > e.serial;
  }
  equal(e) {
    return this.serial === e.serial;
  }
  isSameAs(e) {
    return this.equal(e);
  }
  with(e) {
    if ("serial" in e)
      return this._getLatestMessageVersion(e);
    if (e.type === P.Created)
      throw new u.ErrorInfo("cannot apply a created event to a message", 4e4, 400);
    if (e.type === M.Summary) {
      if (e.summary.messageSerial !== this.serial)
        throw new u.ErrorInfo("cannot apply event for a different message", 4e4, 400);
      const t = {
        unique: D(e.summary.unique),
        distinct: D(e.summary.distinct),
        multiple: D(e.summary.multiple)
      };
      return x._clone(this, { reactions: t });
    }
    return this._getLatestMessageVersion(e.message);
  }
  _compareVersions(e, t, r) {
    return e.equal(t) ? e.equal(t) && r(e.version, t.version) : !1;
  }
  /**
   * Get the latest message version, based on the event.
   * If "this" is the latest version, return "this", otherwise clone the message and apply the reactions.
   * @param message The message to get the latest version of
   * @returns The latest message version
   */
  _getLatestMessageVersion(e) {
    if (e.serial !== this.serial)
      throw new u.ErrorInfo("cannot apply event for a different message", 4e4, 400);
    return this._isNewerOrSameVersionOf(e) ? this : x._clone(e, { reactions: this.reactions });
  }
  // Clone a message, optionally replace the given fields
  static _clone(e, t) {
    return new x({
      serial: t?.serial ?? e.serial,
      clientId: t?.clientId ?? e.clientId,
      text: t?.text ?? e.text,
      metadata: t?.metadata ?? D(e.metadata),
      headers: t?.headers ?? D(e.headers),
      action: t?.action ?? e.action,
      version: t?.version ?? D(e.version),
      timestamp: t?.timestamp ?? e.timestamp,
      reactions: t?.reactions ?? D(e.reactions)
    });
  }
  copy(e = {}) {
    return x._clone(this, e);
  }
}
const xe = () => ({
  unique: {},
  distinct: {},
  multiple: {}
}), yr = (n) => {
  const e = n, t = e.data && typeof e.data == "object" ? e.data : {}, r = e.extras && typeof e.extras == "object" ? e.extras : {}, i = e.clientId || "", c = t.text || "", l = new Date(e.timestamp || 0), d = e.serial || "", g = t.metadata && typeof t.metadata == "object" ? t.metadata : {}, m = r.headers || {}, _ = {
    ...e.version,
    // Spec: CHA-M4k6
    serial: e.version.serial || d,
    // Spec: CHA-M4k7
    timestamp: new Date(e.version.timestamp || l)
  }, S = Object.values(R).includes(e.action) ? e.action : R.MessageCreate;
  return new x({
    serial: d,
    clientId: i,
    text: c,
    metadata: g,
    headers: m,
    action: S,
    version: _,
    timestamp: l,
    reactions: xe()
  });
}, W = (n) => {
  let e = "";
  if (typeof n == "string")
    e = n;
  else
    try {
      "serial" in n && (e = n.serial);
    } catch {
    }
  if (e === "")
    throw new u.ErrorInfo("invalid serial; must be string or object with serial property", 4e4, 400);
  return e;
}, br = {
  "annotation.create": M.Create,
  "annotation.delete": M.Delete
};
class It {
  constructor(e, t, r, i, c) {
    this._logger = e, this._options = t, this._api = r, this._roomName = i, this._channel = c, this._emitter = new A(), this._unsubscribeMessageEvents = F(c, this._processMessageEvent.bind(this)), this._options?.rawMessageReactions && (this._unsubscribeAnnotationEvents = F(c.annotations, this._processAnnotationEvent.bind(this))), this._defaultType = this._options?.defaultMessageReactionType ?? z.Distinct;
  }
  _processAnnotationEvent(e) {
    this._logger.trace("MessagesReactions._processAnnotationEvent();", { event: e });
    const t = _r[e.type];
    if (!t) {
      this._logger.info("MessagesReactions._processAnnotationEvent(); ignoring unknown reaction type", { event: e });
      return;
    }
    const r = br[e.action];
    if (!r) {
      this._logger.info("MessagesReactions._processAnnotationEvent(); ignoring unknown reaction event type", { event: e });
      return;
    }
    const i = e.name ?? "", c = {
      type: r,
      timestamp: new Date(e.timestamp),
      reaction: {
        messageSerial: e.messageSerial,
        type: t,
        name: i,
        clientId: e.clientId ?? ""
      }
    };
    e.count ? c.reaction.count = e.count : r === M.Create && t === z.Multiple && (c.reaction.count = 1), this._emitter.emit(r, c);
  }
  _processMessageEvent(e) {
    if (this._logger.trace("MessagesReactions._processMessageEvent();", { event: e }), e.action !== R.MessageAnnotationSummary.valueOf())
      return;
    const t = e.serial, r = e.annotations.summary, i = r[he.Unique] ?? {}, c = r[he.Distinct] ?? {}, l = r[he.Multiple] ?? {};
    this._emitter.emit(M.Summary, {
      type: M.Summary,
      summary: {
        messageSerial: t,
        unique: i,
        distinct: c,
        multiple: l
      }
    });
  }
  /**
   * @inheritDoc
   */
  send(e, t) {
    this._logger.trace("MessagesReactions.send();", { messageSerial: e, params: t });
    const r = W(e);
    let { type: i, count: c } = t;
    i || (i = this._defaultType), i === z.Multiple && !c && (c = 1);
    const l = { type: i, name: t.name };
    return c && (l.count = c), this._api.sendMessageReaction(this._roomName, r, l);
  }
  /**
   * @inheritDoc
   */
  delete(e, t) {
    this._logger.trace("MessagesReactions.delete();", { messageSerial: e, params: t });
    const r = W(e);
    let i = t?.type;
    if (i || (i = this._defaultType), i !== z.Unique && !t?.name)
      throw new u.ErrorInfo(`cannot delete reaction of type ${i} without a name`, 40001, 400);
    const c = { type: i };
    return i !== z.Unique && (c.name = t?.name), this._api.deleteMessageReaction(this._roomName, r, c);
  }
  /**
   * @inheritDoc
   */
  subscribe(e) {
    this._logger.trace("MessagesReactions.subscribe();");
    const t = v(e);
    return this._emitter.on(M.Summary, t), {
      unsubscribe: () => {
        this._emitter.off(t);
      }
    };
  }
  /**
   * @inheritDoc
   */
  subscribeRaw(e) {
    if (this._logger.trace("MessagesReactions.subscribeRaw();"), !this._options?.rawMessageReactions)
      throw new u.ErrorInfo("Raw message reactions are not enabled", 40001, 400);
    const t = v(e);
    return this._emitter.on([M.Create, M.Delete], t), {
      unsubscribe: () => {
        this._emitter.off(t);
      }
    };
  }
  /**
   * Merges the channel options to add support for message reactions.
   * @param roomOptions The room options to merge for.
   * @returns A function that merges the channel options for the room with the ones required for presence.
   */
  static channelOptionMerger(e) {
    return (t) => (t.modes.includes("ANNOTATION_PUBLISH") || t.modes.push("ANNOTATION_PUBLISH"), e.messages.rawMessageReactions && !t.modes.includes("ANNOTATION_SUBSCRIBE") && t.modes.push("ANNOTATION_SUBSCRIBE"), t);
  }
  clientReactions(e, t) {
    this._logger.trace("MessagesReactions.clientReactions();", { messageSerial: e, clientId: t });
    const r = W(e);
    return this._api.getClientReactions(this._roomName, r, t);
  }
  /**
   * Disposes of the message reactions instance, removing all listeners and subscriptions.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._logger.trace("DefaultMessageReactions.dispose();"), this._emitter.off(), this._unsubscribeMessageEvents(), this._unsubscribeAnnotationEvents?.(), this._logger.debug("DefaultMessageReactions.dispose(); disposed successfully");
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
}
const ue = (n) => {
  const e = {
    ...xe(),
    ...n.reactions
  }, t = Object.values(R).includes(n.action) ? n.action : R.MessageCreate, r = {
    serial: n.version.serial,
    timestamp: new Date(n.version.timestamp),
    clientId: n.version.clientId,
    description: n.version.description,
    metadata: n.version.metadata
  };
  return new x({
    serial: n.serial,
    clientId: n.clientId,
    text: n.text,
    metadata: n.metadata,
    headers: n.headers,
    action: t,
    version: r,
    timestamp: new Date(n.timestamp),
    reactions: e
  });
}, wr = /* @__PURE__ */ new Map([
  [R.MessageCreate, P.Created],
  [R.MessageUpdate, P.Updated],
  [R.MessageDelete, P.Deleted]
]);
var Ie = /* @__PURE__ */ ((n) => (n.OldestFirst = "oldestFirst", n.NewestFirst = "newestFirst", n))(Ie || {});
class Sr {
  /**
   * Constructs a new `DefaultMessages` instance.
   * @param roomName The unique identifier of the room.
   * @param options The room options for the messages.
   * @param channel An instance of the Realtime channel for the room.
   * @param chatApi An instance of the ChatApi.
   * @param clientId The client ID of the user.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, r, i, c, l) {
    this._pendingPromiseRejecters = /* @__PURE__ */ new Set(), this._pendingAttachListeners = /* @__PURE__ */ new Set(), this._emitter = new A(), this._roomName = e, this._options = t, this._channel = r, this._chatApi = i, this._clientId = c, this._logger = l, this._listenerSubscriptionPoints = /* @__PURE__ */ new Map(), this._reactions = new It(this._logger, t, this._chatApi, this._roomName, this._channel);
    const d = this._processEvent.bind(this), g = (_) => {
      this._handleAttach(_.resumed);
    }, m = (_) => {
      _.current === "attached" && _.previous === "attached" && this._handleAttach(_.resumed);
    };
    this._unsubscribeMessageEvents = F(this._channel, [Ct.ChatMessage], d), this._offChannelAttached = L(this._channel, "attached", g), this._offChannelUpdate = L(this._channel, "update", m);
  }
  /**
   * @inheritdoc
   */
  get reactions() {
    return this._reactions;
  }
  /**
   * @inheritdoc
   */
  async _getBeforeSubscriptionStart(e, t) {
    this._logger.trace("DefaultSubscriptionManager.getBeforeSubscriptionStart();");
    const r = this._listenerSubscriptionPoints.get(e);
    if (r === void 0)
      throw this._logger.error(
        "DefaultSubscriptionManager.getBeforeSubscriptionStart(); listener has not been subscribed yet"
      ), new u.ErrorInfo(
        "cannot query history; listener has not been subscribed yet",
        4e4,
        400
      );
    const i = await r;
    return this._chatApi.history(this._roomName, {
      ...t,
      orderBy: "newestFirst",
      ...i
    });
  }
  /**
   * Handle the case where the channel experiences a detach and reattaches.
   * @param fromResume Whether the attach is from a resume operation.
   */
  _handleAttach(e) {
    if (this._logger.trace("DefaultSubscriptionManager.handleAttach();"), e) return;
    const t = this._subscribeAtChannelAttach();
    for (const [r] of this._listenerSubscriptionPoints.entries())
      this._listenerSubscriptionPoints.set(r, t);
  }
  /**
   * Create a promise that resolves with the attachSerial of the channel or the serial of the latest message.
   * @returns A promise that resolves to an object containing fromSerial and subscriptionPoint.
   */
  async _resolveSubscriptionStart() {
    const e = this._getChannelProperties();
    if (e.state === "attached") {
      if (e.properties.channelSerial)
        return { fromSerial: e.properties.channelSerial };
      throw this._logger.error("DefaultSubscriptionManager.handleAttach(); channelSerial is undefined"), new u.ErrorInfo("channel is attached, but channelSerial is not defined", 4e4, 400);
    }
    return this._subscribeAtChannelAttach();
  }
  _getChannelProperties() {
    return this._channel;
  }
  async _subscribeAtChannelAttach() {
    const e = this._getChannelProperties();
    return new Promise((t, r) => {
      this._pendingPromiseRejecters.add(r);
      const i = () => {
        this._pendingPromiseRejecters.delete(r);
      };
      if (e.state === "attached") {
        this._logger.debug("Messages._subscribeAtChannelAttach(); channel is attached already, using attachSerial", {
          attachSerial: e.properties.attachSerial
        }), i(), e.properties.attachSerial ? t({ fromSerial: e.properties.attachSerial }) : (this._logger.error("DefaultSubscriptionManager.handleAttach(); attachSerial is undefined"), i(), r(
          new u.ErrorInfo("channel is attached, but attachSerial is not defined", 4e4, 400)
        ));
        return;
      }
      const c = hr(e, "attached", () => {
        this._logger.debug("Messages._subscribeAtChannelAttach(); channel is now attached, using attachSerial", {
          attachSerial: e.properties.attachSerial
        }), i(), this._pendingAttachListeners.delete(c), e.properties.attachSerial ? t({ fromSerial: e.properties.attachSerial }) : (this._logger.error("DefaultSubscriptionManager.handleAttach(); attachSerial is undefined"), r(
          new u.ErrorInfo("channel is attached, but attachSerial is not defined", 4e4, 400)
        ));
      });
      this._pendingAttachListeners.add(c);
    });
  }
  /**
   * @inheritdoc
   */
  async history(e) {
    return this._logger.trace("Messages.query();"), this._chatApi.history(this._roomName, e);
  }
  /**
   * @inheritdoc
   */
  get(e) {
    return this._logger.trace("Messages.get();", { serial: e }), this._chatApi.getMessage(this._roomName, W(e));
  }
  /**
   * @inheritdoc
   */
  async send(e) {
    this._logger.trace("Messages.send();", { params: e });
    const { text: t, metadata: r, headers: i } = e, c = await this._chatApi.sendMessage(this._roomName, { text: t, headers: i, metadata: r }), l = new Date(c.timestamp);
    return new x({
      serial: c.serial,
      clientId: this._clientId,
      text: t,
      metadata: r ?? {},
      headers: i ?? {},
      action: R.MessageCreate,
      version: {
        serial: c.serial,
        timestamp: l
      },
      timestamp: l,
      reactions: xe()
    });
  }
  /**
   * @inheritdoc
   */
  async delete(e, t) {
    this._logger.trace("Messages.delete();", { params: t }), e = W(e), this._logger.debug("Messages.delete(); serial", { serial: e });
    const r = await this._chatApi.deleteMessage(this._roomName, e, t);
    return ue(r);
  }
  /**
   * @inheritdoc
   */
  async update(e, t, r) {
    this._logger.trace("Messages.update();", { updateParams: t, details: r }), e = W(e), this._logger.debug("Messages.update(); serial", { serial: e });
    const i = await this._chatApi.updateMessage(this._roomName, e, {
      message: {
        text: t.text,
        metadata: t.metadata,
        headers: t.headers
      },
      ...r
    });
    return this._logger.debug("Messages.update(); message update successfully", { updateParams: t }), ue(i);
  }
  /**
   * @inheritdoc
   */
  subscribe(e) {
    this._logger.trace("Messages.subscribe();");
    const t = v(e);
    this._emitter.on(
      [P.Created, P.Updated, P.Deleted],
      t
    );
    const r = this._resolveSubscriptionStart();
    return r.catch(() => {
      this._logger.debug("Messages.subscribe(); subscription point was not resolved before the room was released");
    }), this._listenerSubscriptionPoints.set(t, r), {
      unsubscribe: () => {
        this._listenerSubscriptionPoints.delete(t), this._logger.trace("Messages.unsubscribe();"), this._emitter.off(t);
      },
      historyBeforeSubscribe: (i) => this._getBeforeSubscriptionStart(t, i)
    };
  }
  _processEvent(e) {
    this._logger.trace("Messages._processEvent();", {
      channelEventMessage: e
    });
    const { action: t } = e, r = wr.get(t);
    if (!r) {
      this._logger.debug("Messages._processEvent(); received unknown message action", { action: t });
      return;
    }
    const i = yr(e);
    this._emitter.emit(r, { type: r, message: i });
  }
  /**
   * Disposes of the messages instance, removing all listeners and subscriptions.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._logger.trace("DefaultMessages.dispose();"), this._emitter.off();
    const e = new u.ErrorInfo("room has been disposed", 4e4, 400);
    for (const t of this._pendingPromiseRejecters)
      try {
        t(e);
      } catch {
      }
    this._pendingPromiseRejecters.clear(), this._listenerSubscriptionPoints.clear();
    for (const t of this._pendingAttachListeners)
      t();
    this._pendingAttachListeners.clear(), this._unsubscribeMessageEvents(), this._offChannelAttached(), this._offChannelUpdate(), this._reactions.dispose(), this._logger.debug("DefaultMessages.dispose(); disposed successfully");
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
}
class vr {
  constructor(e, t) {
    this._apiProtocolVersion = 4, this._realtime = e, this._logger = t;
  }
  async history(e, t) {
    const r = { ...t };
    if (t.orderBy)
      switch (t.orderBy) {
        case Ie.NewestFirst: {
          r.direction = "backwards";
          break;
        }
        case Ie.OldestFirst: {
          r.direction = "forwards";
          break;
        }
        default:
          throw new u.ErrorInfo(`invalid orderBy value: ${t.orderBy}`, 4e4, 400);
      }
    const i = await this._makeAuthorizedPaginatedRequest(
      this._roomUrl(e, "/messages"),
      r
    );
    return this._recursivePaginateMessages(i);
  }
  _recursivePaginateMessages(e) {
    const t = {};
    return t.items = e.items.map((r) => ue(r)), t.next = () => e.next().then((r) => r ? this._recursivePaginateMessages(r) : null), t.first = () => e.first().then((r) => this._recursivePaginateMessages(r)), t.current = () => e.current().then((r) => this._recursivePaginateMessages(r)), t.hasNext = () => e.hasNext(), t.isLast = () => e.isLast(), { ...e, ...t };
  }
  async getMessage(e, t) {
    const r = await this._makeAuthorizedRequest(this._messageUrl(e, t), "GET");
    return ue(r);
  }
  deleteMessage(e, t, r) {
    const i = {
      ...r?.description && { description: r.description },
      ...r?.metadata && { metadata: r.metadata }
    };
    return this._makeAuthorizedRequest(
      this._messageUrl(e, t, "/delete"),
      "POST",
      i,
      {}
    );
  }
  sendMessage(e, t) {
    const r = {
      text: t.text,
      ...t.metadata && { metadata: t.metadata },
      ...t.headers && { headers: t.headers }
    };
    return this._makeAuthorizedRequest(this._roomUrl(e, "/messages"), "POST", r);
  }
  updateMessage(e, t, r) {
    return this._makeAuthorizedRequest(this._messageUrl(e, t), "PUT", r);
  }
  sendMessageReaction(e, t, r) {
    return this._makeAuthorizedRequest(this._messageUrl(e, t, "/reactions"), "POST", r);
  }
  deleteMessageReaction(e, t, r) {
    return this._makeAuthorizedRequest(this._messageUrl(e, t, "/reactions"), "DELETE", void 0, r);
  }
  getClientReactions(e, t, r) {
    const i = r ? { forClientId: r } : {};
    return this._makeAuthorizedRequest(
      this._messageUrl(e, t, "/client-reactions"),
      "GET",
      void 0,
      i
    );
  }
  getOccupancy(e) {
    return this._makeAuthorizedRequest(this._roomUrl(e, "/occupancy"), "GET");
  }
  async _makeAuthorizedRequest(e, t, r, i) {
    return (await this._doRequest(e, t, i, r)).items[0];
  }
  async _makeAuthorizedPaginatedRequest(e, t, r) {
    return this._doRequest(e, "GET", t, r);
  }
  async _doRequest(e, t, r, i) {
    const c = await this._realtime.request(t, e, this._apiProtocolVersion, r, i);
    if (!c.success)
      throw this._logger.error("ChatApi._doRequest(); failed to make request", {
        url: e,
        method: t,
        statusCode: c.statusCode,
        errorCode: c.errorCode,
        errorMessage: c.errorMessage
      }), new u.ErrorInfo(c.errorMessage, c.errorCode, c.statusCode);
    return c;
  }
  /**
   * Returns a URL for a specific room.
   * @param roomName Name of the room
   * @param suffix The suffix to add to the room URL, prefixed with /
   * @returns string The formatted URL
   */
  _roomUrl(e, t = "") {
    return `/chat/v4/rooms/${encodeURIComponent(e)}${t}`;
  }
  /**
   * Returns a URL for a specific message in the room.
   * @param roomName string Name of the room
   * @param serial string The serial of the message
   * @param suffix The suffix to add to the room URL, prefixed with /
   * @returns string The formatted URL
   */
  _messageUrl(e, t, r = "") {
    return `${this._roomUrl(e, "/messages")}/${encodeURIComponent(t)}${r}`;
  }
}
var B = /* @__PURE__ */ ((n) => (n[n.BadRequest = 4e4] = "BadRequest", n[n.MessageRejectedByBeforePublishRule = 42211] = "MessageRejectedByBeforePublishRule", n[n.MessageRejectedByModeration = 42213] = "MessageRejectedByModeration", n[n.PresenceAutoReentryFailed = 91004] = "PresenceAutoReentryFailed", n[n.RoomDiscontinuity = 102100] = "RoomDiscontinuity", n[n.RoomInFailedState = 102101] = "RoomInFailedState", n[n.RoomIsReleasing = 102102] = "RoomIsReleasing", n[n.RoomIsReleased = 102103] = "RoomIsReleased", n[n.RoomReleasedBeforeOperationCompleted = 102106] = "RoomReleasedBeforeOperationCompleted", n))(B || {});
const Jr = (n, e) => n.code === e, Rr = (n) => `${n}::$chat`, ge = "0.14.1", Dt = `chat-js/${ge}`, Tr = `chat-react/${ge}`, xt = ["PUBLISH", "SUBSCRIBE"], Mr = {
  params: { agent: Dt },
  attachOnSubscribe: !1,
  modes: xt
}, Ar = {
  // Spec: CHA-IN1b1
  params: { agent: `${Dt} ${Tr}` },
  attachOnSubscribe: !1,
  modes: xt
};
class Er {
  constructor(e, t, r, i) {
    r.trace("ChannelManager();", { isReact: i }), this._realtime = t, this._logger = r, this._isReact = i, this._registeredOptions = this._defaultChannelOptions(), this._channelId = Rr(e);
  }
  mergeOptions(e) {
    if (this._logger.trace("ChannelManager.mergeOptions();"), this._resolvedChannel)
      throw this._logger.error("channel options cannot be modified after the channel has been requested"), new u.ErrorInfo("channel options cannot be modified after the channel has been requested", 4e4, 400);
    this._registeredOptions = e(this._registeredOptions);
  }
  get() {
    return this._logger.trace("ChannelManager.get();"), this._resolvedChannel ??= this._realtime.channels.get(this._channelId, this._registeredOptions), this._resolvedChannel;
  }
  release() {
    this._logger.trace("ChannelManager.release();", { channelId: this._channelId }), this._resolvedChannel && this._realtime.channels.release(this._channelId);
  }
  _defaultChannelOptions() {
    this._logger.trace("ChannelManager._defaultChannelOptions();");
    const e = this._isReact ? Ar : Mr;
    return this._logger.trace(this._isReact ? "using react channel options" : "using default channel options"), { ...e, modes: [...e.modes ?? []] };
  }
}
const Cr = (n) => {
  const e = n;
  let t = 0, r = 0;
  if (!e.data || typeof e.data != "object")
    return { connections: t, presenceMembers: r };
  const { metrics: i } = e.data;
  return !i || typeof i != "object" ? { connections: t, presenceMembers: r } : (typeof i.connections == "number" && Number.isInteger(i.connections) && (t = i.connections), typeof i.presenceMembers == "number" && Number.isInteger(i.presenceMembers) && (r = i.presenceMembers), { connections: t, presenceMembers: r });
};
class Rt {
  /**
   * Constructs a new `DefaultOccupancy` instance.
   * @param roomName The unique identifier of the room.
   * @param channel An instance of the Realtime channel.
   * @param chatApi An instance of the ChatApi.
   * @param logger An instance of the Logger.
   * @param roomOptions The room options.
   */
  constructor(e, t, r, i, c) {
    this._emitter = new A(), this._roomName = e, this._channel = t, this._chatApi = r, this._logger = i, this._roomOptions = c;
    const l = this._internalOccupancyListener.bind(this);
    this._roomOptions.occupancy.enableEvents ? (this._logger.debug("DefaultOccupancy(); subscribing to occupancy events"), this._unsubscribeOccupancyEvents = F(
      this._channel,
      [Ot.Occupancy],
      l
    )) : this._unsubscribeOccupancyEvents = () => {
    };
  }
  /**
   * @inheritdoc
   */
  subscribe(e) {
    if (this._logger.trace("Occupancy.subscribe();"), !this._roomOptions.occupancy.enableEvents)
      throw new u.ErrorInfo(
        "cannot subscribe to occupancy; occupancy events are not enabled in room options",
        4e4,
        400
      );
    const t = v(e);
    return this._emitter.on(t), {
      unsubscribe: () => {
        this._logger.trace("Occupancy.unsubscribe();"), this._emitter.off(t);
      }
    };
  }
  /**
   * @inheritdoc
   */
  async get() {
    return this._logger.trace("Occupancy.get();"), this._chatApi.getOccupancy(this._roomName);
  }
  /**
   * @inheritdoc
   */
  current() {
    if (this._logger.trace("Occupancy.current();"), !this._roomOptions.occupancy.enableEvents)
      throw new u.ErrorInfo(
        "cannot get current occupancy; occupancy events are not enabled in room options",
        4e4,
        400
      );
    return this._latestOccupancyData;
  }
  /**
   * An internal listener that listens for occupancy events from the underlying channel and translates them into
   * occupancy events for the public API.
   * @param message The inbound message containing occupancy data.
   */
  _internalOccupancyListener(e) {
    this._logger.trace("Occupancy._internalOccupancyListener();", e), this._latestOccupancyData = Cr(e), this._emitter.emit(Oe.Updated, {
      type: Oe.Updated,
      occupancy: this._latestOccupancyData
    });
  }
  /**
   * Merges the channel options for the room with the ones required for occupancy.
   * @param roomOptions The internal room options.
   * @returns A function that merges the channel options for the room with the ones required for occupancy.
   */
  static channelOptionMerger(e) {
    return (t) => e.occupancy.enableEvents ? { ...t, params: { ...t.params, occupancy: "metrics" } } : t;
  }
  /**
   * Disposes of the occupancy instance, removing all listeners and subscriptions.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._logger.trace("DefaultOccupancy.dispose();"), this._unsubscribeOccupancyEvents(), this._emitter.off(), this._logger.debug("DefaultOccupancy.dispose(); disposed successfully");
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
}
class Tt {
  /**
   * Constructs a new `DefaultPresence` instance.
   * @param channel The Realtime channel instance.
   * @param clientId The client ID, attached to presences messages as an identifier of the sender.
   * A channel can have multiple connections using the same clientId.
   * @param logger An instance of the Logger.
   * @param options The room options.
   */
  constructor(e, t, r, i) {
    this._emitter = new A(), this._stateEmitter = new A(), this._presenceState = {
      present: !1
    }, this.subscribeToEvents = (g) => {
      this._emitter.emit(g.action, {
        type: g.action,
        member: this._realtimeMemberToPresenceMember(g)
      });
    }, this._channel = e, this._clientId = t, this._logger = r, this._options = i;
    const c = this.subscribeToEvents.bind(this), l = (g) => {
      if (g.reason?.code === 91004) {
        this._logger.debug("Presence auto-reentry failed", { reason: g.reason }), this._emitPresenceStateChange(!1, g.reason);
        return;
      }
      if (g.current === "detached") {
        this._emitPresenceStateChange(!1);
        return;
      }
    }, d = (g) => {
      this._emitPresenceStateChange(!1, g.reason);
    };
    this._offChannelUpdate = L(this._channel, "update", l), this._offChannelDetach = L(this._channel, ["detached", "failed"], d), this._unsubscribePresenceEvents = F(this._channel.presence, c);
  }
  /**
   * @inheritDoc
   */
  async get(e) {
    return this._logger.trace("Presence.get()", { params: e }), this._assertChannelState(), (await this._channel.presence.get(e)).map((r) => this._realtimeMemberToPresenceMember(r));
  }
  /**
   * @inheritDoc
   */
  async isUserPresent(e) {
    return this._logger.trace("Presence.isUserPresent()", { clientId: e }), this._assertChannelState(), (await this._channel.presence.get({ clientId: e })).length > 0;
  }
  /**
   * @inheritDoc
   */
  async enter(e) {
    this._logger.trace("Presence.enter()", { data: e }), this._assertChannelState();
    try {
      await this._channel.presence.enterClient(this._clientId, e), this._emitPresenceStateChange(!0);
    } catch (t) {
      throw this._emitPresenceStateChange(!1, t), t;
    }
  }
  /**
   * @inheritDoc
   */
  async update(e) {
    this._logger.trace("Presence.update()", { data: e }), this._assertChannelState();
    try {
      await this._channel.presence.updateClient(this._clientId, e), this._emitPresenceStateChange(!0);
    } catch (t) {
      throw this._emitPresenceStateChange(!1, t), t;
    }
  }
  /**
   * @inheritDoc
   */
  async leave(e) {
    this._logger.trace("Presence.leave()", { data: e }), this._assertChannelState();
    try {
      await this._channel.presence.leaveClient(this._clientId, e), this._emitPresenceStateChange(!1);
    } catch (t) {
      throw this._emitPresenceStateChange(!1, t), t;
    }
  }
  subscribe(e, t) {
    if (this._logger.trace("Presence.subscribe(); listenerOrEvents", { listenerOrEvents: e }), !this._options.presence.enableEvents)
      throw this._logger.error("could not subscribe to presence; presence events are not enabled"), new u.ErrorInfo("could not subscribe to presence; presence events are not enabled", 4e4, 400);
    if (!e && !t)
      throw this._logger.error("could not subscribe to presence; invalid arguments"), new u.ErrorInfo("could not subscribe listener: invalid arguments", 4e4, 400);
    if (t) {
      const r = v(t);
      return this._emitter.on(e, r), {
        unsubscribe: () => {
          this._logger.trace("Presence.unsubscribe();", { events: e }), this._emitter.off(r);
        }
      };
    } else {
      const r = v(e);
      return this._emitter.on(r), {
        unsubscribe: () => {
          this._logger.trace("Presence.unsubscribe();"), this._emitter.off(r);
        }
      };
    }
  }
  /**
   * Merges the channel options for the room with the ones required for presence.
   * @param roomOptions The room options to merge for.
   * @returns A function that merges the channel options for the room with the ones required for presence.
   */
  static channelOptionMerger(e) {
    return (t) => (t.modes.includes("PRESENCE") || t.modes.push("PRESENCE"), e.presence.enableEvents && !t.modes.includes("PRESENCE_SUBSCRIBE") && t.modes.push("PRESENCE_SUBSCRIBE"), t);
  }
  /**
   * Disposes of the presence instance, removing all listeners and subscriptions.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._logger.trace("DefaultPresence.dispose();"), this._emitter.off(), this._unsubscribePresenceEvents(), this._offChannelUpdate(), this._offChannelDetach(), this._logger.debug("DefaultPresence.dispose(); disposed successfully");
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
  /**
   * Converts an Ably presence message to a presence member.
   * @param member The Ably presence message to convert.
   * @returns The presence member.
   */
  _realtimeMemberToPresenceMember(e) {
    return {
      ...e,
      data: e.data,
      updatedAt: new Date(e.timestamp)
    };
  }
  _assertChannelState() {
    if (this._channel.state !== "attaching" && this._channel.state !== "attached")
      throw this._logger.error("could not perform presence operation; room is not attached"), new u.ErrorInfo("could not perform presence operation; room is not attached", 4e4, 400);
  }
  /**
   * Private method to emit the presence state change event.
   * @param present - Whether the user is present
   * @param error - Optional error information
   */
  _emitPresenceStateChange(e, t) {
    this._logger.trace("Presence._emitPresenceStateChange()", { present: e, error: t });
    const r = { ...this._presenceState };
    this._presenceState = { present: e };
    const i = {
      previous: r,
      current: this._presenceState,
      error: t
    };
    this._stateEmitter.emit("presence.state.change", i);
  }
  /**
   * @param listener The listener to subscribe to presence state changes.
   * @returns A subscription that can be used to unsubscribe from presence state changes.
   * @internal
   */
  onPresenceStateChange(e) {
    this._logger.trace("Presence.onPresenceStateChange()");
    const t = v(e);
    return this._stateEmitter.on("presence.state.change", t), {
      unsubscribe: () => {
        this._logger.trace("Presence.unsubscribeFromPresenceStateChanges()"), this._stateEmitter.off(t);
      }
    };
  }
}
const le = new Error("request for lock canceled");
var Or = function(n, e, t, r) {
  function i(c) {
    return c instanceof t ? c : new t(function(l) {
      l(c);
    });
  }
  return new (t || (t = Promise))(function(c, l) {
    function d(_) {
      try {
        m(r.next(_));
      } catch (S) {
        l(S);
      }
    }
    function g(_) {
      try {
        m(r.throw(_));
      } catch (S) {
        l(S);
      }
    }
    function m(_) {
      _.done ? c(_.value) : i(_.value).then(d, g);
    }
    m((r = r.apply(n, e || [])).next());
  });
};
class Ir {
  constructor(e, t = le) {
    this._value = e, this._cancelError = t, this._queue = [], this._weightedWaiters = [];
  }
  acquire(e = 1, t = 0) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    return new Promise((r, i) => {
      const c = { resolve: r, reject: i, weight: e, priority: t }, l = Lt(this._queue, (d) => t <= d.priority);
      l === -1 && e <= this._value ? this._dispatchItem(c) : this._queue.splice(l + 1, 0, c);
    });
  }
  runExclusive(e) {
    return Or(this, arguments, void 0, function* (t, r = 1, i = 0) {
      const [c, l] = yield this.acquire(r, i);
      try {
        return yield t(c);
      } finally {
        l();
      }
    });
  }
  waitForUnlock(e = 1, t = 0) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    return this._couldLockImmediately(e, t) ? Promise.resolve() : new Promise((r) => {
      this._weightedWaiters[e - 1] || (this._weightedWaiters[e - 1] = []), Dr(this._weightedWaiters[e - 1], { resolve: r, priority: t });
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(e) {
    this._value = e, this._dispatchQueue();
  }
  release(e = 1) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    this._value += e, this._dispatchQueue();
  }
  cancel() {
    this._queue.forEach((e) => e.reject(this._cancelError)), this._queue = [];
  }
  _dispatchQueue() {
    for (this._drainUnlockWaiters(); this._queue.length > 0 && this._queue[0].weight <= this._value; )
      this._dispatchItem(this._queue.shift()), this._drainUnlockWaiters();
  }
  _dispatchItem(e) {
    const t = this._value;
    this._value -= e.weight, e.resolve([t, this._newReleaser(e.weight)]);
  }
  _newReleaser(e) {
    let t = !1;
    return () => {
      t || (t = !0, this.release(e));
    };
  }
  _drainUnlockWaiters() {
    if (this._queue.length === 0)
      for (let e = this._value; e > 0; e--) {
        const t = this._weightedWaiters[e - 1];
        t && (t.forEach((r) => r.resolve()), this._weightedWaiters[e - 1] = []);
      }
    else {
      const e = this._queue[0].priority;
      for (let t = this._value; t > 0; t--) {
        const r = this._weightedWaiters[t - 1];
        if (!r)
          continue;
        const i = r.findIndex((c) => c.priority <= e);
        (i === -1 ? r : r.splice(0, i)).forEach((c) => c.resolve());
      }
    }
  }
  _couldLockImmediately(e, t) {
    return (this._queue.length === 0 || this._queue[0].priority < t) && e <= this._value;
  }
}
function Dr(n, e) {
  const t = Lt(n, (r) => e.priority <= r.priority);
  n.splice(t + 1, 0, e);
}
function Lt(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    if (e(n[t]))
      return t;
  return -1;
}
var xr = function(n, e, t, r) {
  function i(c) {
    return c instanceof t ? c : new t(function(l) {
      l(c);
    });
  }
  return new (t || (t = Promise))(function(c, l) {
    function d(_) {
      try {
        m(r.next(_));
      } catch (S) {
        l(S);
      }
    }
    function g(_) {
      try {
        m(r.throw(_));
      } catch (S) {
        l(S);
      }
    }
    function m(_) {
      _.done ? c(_.value) : i(_.value).then(d, g);
    }
    m((r = r.apply(n, e || [])).next());
  });
};
class Pt {
  constructor(e) {
    this._semaphore = new Ir(1, e);
  }
  acquire() {
    return xr(this, arguments, void 0, function* (e = 0) {
      const [, t] = yield this._semaphore.acquire(1, e);
      return t;
    });
  }
  runExclusive(e, t = 0) {
    return this._semaphore.runExclusive(() => e(), 1, t);
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock(e = 0) {
    return this._semaphore.waitForUnlock(1, e);
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
var f = /* @__PURE__ */ ((n) => (n.Initializing = "initializing", n.Initialized = "initialized", n.Attaching = "attaching", n.Attached = "attached", n.Detaching = "detaching", n.Detached = "detached", n.Suspended = "suspended", n.Failed = "failed", n.Releasing = "releasing", n.Released = "released", n))(f || {});
class Lr {
  /**
   * Constructs a new DefaultRoomLifecycle instance.
   * @param logger An instance of the Logger.
   */
  constructor(e) {
    this._status = "initialized", this._emitter = new A(), this._logger = e;
  }
  /**
   * @inheritdoc
   */
  get status() {
    return this._status;
  }
  /**
   * @inheritdoc
   */
  get error() {
    return this._error;
  }
  /**
   * @inheritdoc
   */
  onChange(e) {
    const t = v(e);
    return this._emitter.on(t), {
      off: () => {
        this._emitter.off(t);
      }
    };
  }
  setStatus(e) {
    const t = {
      current: e.status,
      error: e.error,
      previous: this._status
    };
    this._status = t.current, this._error = t.error, this._logger.info("room status changed", { ...t }), this._emitter.emit(t.current, t);
  }
  /**
   * Disposes of the room lifecycle instance, removing all listeners.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._logger.trace("DefaultRoomLifecycle.dispose();"), this._emitter.off(), this._logger.debug("DefaultRoomLifecycle.dispose(); disposed successfully");
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
}
class Pr {
  constructor(e, t, r) {
    this._channelManager = e, this._roomLifecycle = t, this._logger = r, this._eventEmitter = new A(), this._hasAttachedOnce = !1, this._isExplicitlyDetached = !1, this._mutex = new Pt();
    const i = this._channelStateListener.bind(this), c = this._discontinuityOnAttachedListener.bind(this), l = this._discontinuityOnUpdateListener.bind(this), d = this._channelManager.get();
    this._unsubscribeChannelStateListener = L(d, i), this._offDiscontinuityAttached = L(d, "attached", c), this._offDiscontinuityUpdate = L(d, "update", l);
  }
  /**
   * Registers a handler for discontinuity events.
   * @param handler The function to be called when a discontinuity is detected
   * @returns An object with an off() method to deregister the handler
   */
  onDiscontinuity(e) {
    this._logger.trace("RoomLifecycleManager.onDiscontinuity()");
    const t = v(e);
    return this._eventEmitter.on(J.Discontinuity, t), {
      off: () => {
        this._eventEmitter.off(J.Discontinuity, t);
      }
    };
  }
  /**
   * Attaches to the channel and updates room status accordingly.
   * If the room is released/releasing, this operation fails.
   * If already attached, this is a no-op.
   */
  async attach() {
    await this._mutex.runExclusive(
      async () => {
        if (this._logger.trace("RoomLifecycleManager.attach();"), this._checkRoomNotReleasing("attach"), this._roomStatusIs(f.Attached)) {
          this._logger.debug("RoomLifecycleManager.attach(); room already attached, no-op");
          return;
        }
        const e = this._channelManager.get();
        this._logger.debug("RoomLifecycleManager.attach(); attaching room", {
          channelState: e.state
        });
        try {
          this._setStatus(f.Attaching), await e.attach(), this._setStatus(f.Attached), this._isExplicitlyDetached = !1, this._hasAttachedOnce = !0, this._logger.debug("RoomLifecycleManager.attach(); room attached successfully");
        } catch (t) {
          const r = t, i = new u.ErrorInfo(
            `failed to attach room: ${r.message}`,
            r.code,
            r.statusCode,
            r
          ), c = this._mapChannelStateToRoomStatus(e.state);
          throw this._setStatus(c, i), i;
        }
      },
      1
      /* AttachDetach */
    );
  }
  /**
   * Detaches from the channel and updates room status accordingly.
   * If the room is released/releasing, this operation fails.
   * If already detached, this is a no-op.
   */
  async detach() {
    await this._mutex.runExclusive(
      async () => {
        if (this._logger.trace("RoomLifecycleManager.detach();"), this._roomStatusIs(f.Failed))
          throw new u.ErrorInfo("cannot detach room, room is in failed state", B.RoomInFailedState, 400);
        if (this._checkRoomNotReleasing("detach"), this._roomStatusIs(f.Detached)) {
          this._logger.debug("RoomLifecycleManager.detach(); room already detached, no-op");
          return;
        }
        const e = this._channelManager.get();
        this._logger.debug("RoomLifecycleManager.detach(); detaching room", {
          channelState: e.state
        });
        try {
          this._setStatus(f.Detaching), await e.detach(), this._isExplicitlyDetached = !0, this._setStatus(f.Detached), this._logger.debug("RoomLifecycleManager.detach(); room detached successfully");
        } catch (t) {
          const r = t, i = new u.ErrorInfo(
            `failed to detach room: ${r.message}`,
            r.code,
            r.statusCode,
            r
          ), c = this._mapChannelStateToRoomStatus(e.state);
          throw this._setStatus(c, i), i;
        }
      },
      1
      /* AttachDetach */
    );
  }
  /**
   * Releases the room by detaching the channel and releasing it from the channel manager.
   * If the channel is in a failed state, skips the detach operation.
   * Will retry detach until successful unless in failed state.
   */
  async release() {
    await this._mutex.runExclusive(
      async () => {
        if (this._logger.trace("RoomLifecycleManager.release();"), this._roomStatusIs(f.Released)) {
          this._logger.debug("RoomLifecycleManager.release(); room already released, no-op");
          return;
        }
        if (this._roomStatusIs(f.Initialized) || this._roomStatusIs(f.Detached)) {
          this._logger.debug("RoomLifecycleManager.release(); room is initialized or detached, releasing immediately", {
            status: this._roomLifecycle.status
          }), this._releaseChannel();
          return;
        }
        this._setStatus(f.Releasing);
        const e = this._channelManager.get();
        this._logger.debug("RoomLifecycleManager.release(); attempting channel detach before release", {
          channelState: e.state
        }), await this._channelDetachLoop(e), this._releaseChannel();
      },
      0
      /* Release */
    );
  }
  /**
   * Maps an Ably channel state to a room status
   * @param channelState The Ably channel state to map.
   * @returns The corresponding room status.
   */
  _mapChannelStateToRoomStatus(e) {
    switch (e) {
      case "initialized":
        return f.Initialized;
      case "attaching":
        return f.Attaching;
      case "attached":
        return f.Attached;
      case "detaching":
        return f.Detaching;
      case "detached":
        return f.Detached;
      case "suspended":
        return f.Suspended;
      case "failed":
        return f.Failed;
      default:
        return this._logger.error("RoomLifecycleManager._mapChannelStateToRoomStatus(); unknown channel state", {
          channelState: e
        }), f.Failed;
    }
  }
  _checkRoomNotReleasing(e) {
    switch (this._roomLifecycle.status) {
      case f.Released:
        throw new u.ErrorInfo(`cannot ${e} room, room is released`, B.RoomIsReleased, 400);
      case f.Releasing:
        throw new u.ErrorInfo(`cannot ${e} room, room is currently releasing`, B.RoomIsReleasing, 400);
    }
  }
  /**
   * Returns the current room status
   * @param status The room status to check against.
   * @returns true if the room status matches, false otherwise.
   */
  _roomStatusIs(e) {
    return this._roomLifecycle.status === e;
  }
  /**
   * Disposes of the room lifecycle manager, removing all listeners and subscriptions.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._unsubscribeChannelStateListener(), this._offDiscontinuityAttached(), this._offDiscontinuityUpdate(), this._eventEmitter.off();
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._eventEmitter);
  }
  _channelStateListener(e) {
    if (this._logger.debug("RoomLifecycleManager.channel state changed", {
      oldState: e.previous,
      newState: e.current,
      reason: e.reason,
      resumed: e.resumed
    }), this._operationInProgress()) {
      this._logger.debug(
        "RoomLifecycleManager._startMonitoringChannelState(); ignoring channel state change - operation in progress",
        {
          status: this._roomLifecycle.status
        }
      );
      return;
    }
    const t = this._mapChannelStateToRoomStatus(e.current);
    this._setStatus(t, e.reason);
  }
  _discontinuityOnAttachedListener(e) {
    if (!e.resumed && this._hasAttachedOnce && !this._isExplicitlyDetached) {
      const t = new u.ErrorInfo(
        "discontinuity detected",
        B.RoomDiscontinuity,
        e.reason?.statusCode ?? 0,
        e.reason
      );
      this._logger.warn("RoomLifecycleManager._startMonitoringDiscontinuity(); discontinuity detected", {
        error: t
      }), this._eventEmitter.emit(J.Discontinuity, t);
    }
  }
  _discontinuityOnUpdateListener(e) {
    if (!e.resumed && this._hasAttachedOnce && !this._isExplicitlyDetached && e.current === "attached" && e.previous === "attached") {
      const t = new u.ErrorInfo(
        "discontinuity detected",
        B.RoomDiscontinuity,
        e.reason?.statusCode ?? 0,
        e.reason
      );
      this._logger.warn("RoomLifecycleManager._startMonitoringDiscontinuity(); discontinuity detected", {
        error: t
      }), this._eventEmitter.emit(J.Discontinuity, t);
    }
  }
  async _channelDetachLoop(e) {
    for (; ; ) {
      if (e.state === "failed") {
        this._logger.debug("RoomLifecycleManager._channelDetachLoop(); channel is failed, skipping detach");
        break;
      }
      try {
        await e.detach();
        break;
      } catch (r) {
        this._logger.error("RoomLifecycleManager._channelDetachLoop(); failed to detach channel during release", {
          error: r
        }), await new Promise((i) => setTimeout(i, 250));
      }
    }
  }
  _setStatus(e, t) {
    this._logger.debug("RoomLifecycleManager._setStatus(); updating room status", {
      oldStatus: this._roomLifecycle.status,
      newStatus: e,
      hasError: !!t
    }), this._roomLifecycle.setStatus({ status: e, error: t });
  }
  _releaseChannel() {
    this._channelManager.release(), this._setStatus(f.Released), this._logger.debug("RoomLifecycleManager._releaseChannel(); room released successfully");
  }
  /**
   * Returns whether there is currently an operation (attach/detach/release) in progress
   * @returns True if an operation is in progress, false otherwise.
   */
  _operationInProgress() {
    return this._mutex.isLocked();
  }
  testForceHasAttachedOnce(e) {
    this._logger.trace("RoomLifecycleManager.testForceHasAttachedOnce();", { firstAttach: e }), this._hasAttachedOnce = e;
  }
}
const de = {
  /**
   * The default typing options for a chat room.
   */
  typing: {
    /**
     * The default time that a client will wait between sending one typing heartbeat and the next.
     *
     * Spec: CHA-T10.
     */
    heartbeatThrottleMs: 1e4
  },
  /**
   * The default occupancy options for a chat room.
   */
  occupancy: {
    /**
     * Whether to enable occupancy events.
     */
    enableEvents: !1
  },
  /**
   * The default presence options for the room.
   */
  presence: {
    enableEvents: !0
  },
  /**
   * The default options for messages.
   */
  messages: {
    rawMessageReactions: !1,
    defaultMessageReactionType: z.Distinct
  }
}, Nr = (n) => new u.ErrorInfo(`invalid room configuration: ${n}`, 40001, 400), Ur = (n) => {
  qr(n.typing);
}, qr = (n) => {
  if (n.heartbeatThrottleMs <= 0)
    throw Nr("typing heartbeat interval must be greater than 0");
}, jr = (n) => ({
  ...de.typing,
  ...n?.typing
}), kr = (n) => ({
  ...de.occupancy,
  ...n?.occupancy
}), zr = (n) => ({
  ...de.presence,
  ...n?.presence
}), Br = (n) => ({
  ...de.messages,
  ...n?.messages
}), Fr = (n, e) => ({
  typing: jr(n),
  occupancy: kr(n),
  presence: zr(n),
  messages: Br(n),
  isReactClient: e
}), Mt = (n, e) => ({
  name: n,
  data: e,
  extras: {
    ephemeral: !0
  }
}), $r = (n) => {
  const e = n.extras ? n.extras : {};
  return {
    ...n,
    extras: {
      ...e,
      ephemeral: !0
    }
  };
};
class Hr {
  constructor(e, t, r, i, c, l) {
    this.name = e, this.clientId = t, this.createdAt = r, this.isSelf = i, this.metadata = c, this.headers = l, Object.freeze(this);
  }
}
const Vr = (n, e) => {
  const t = n, r = t.data?.name && typeof t.data.name == "string" ? t.data.name : "", i = t.clientId ?? "", c = t.timestamp ? new Date(t.timestamp) : /* @__PURE__ */ new Date();
  return new Hr(
    r,
    i,
    c,
    e ? e === i : !1,
    t.data?.metadata ?? {},
    t.extras?.headers ?? {}
  );
};
class Gr {
  /**
   * Constructs a new `DefaultRoomReactions` instance.
   * @param channel The Realtime channel instance.
   * @param connection The connection instance.
   * @param clientId The client ID of the user.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, r, i) {
    this._emitter = new A(), this._forwarder = (l) => {
      const d = Vr(l, this._clientId);
      this._emitter.emit(Ce.Reaction, {
        type: Ce.Reaction,
        reaction: d
      });
    }, this._channel = e, this._connection = t, this._clientId = r, this._logger = i;
    const c = this._forwarder.bind(this);
    this._unsubscribeRoomReactionEvents = F(
      this._channel,
      [Ee.Reaction],
      c
    );
  }
  /**
   * @inheritDoc
   */
  send(e) {
    this._logger.trace("RoomReactions.send();", e);
    const { name: t, metadata: r, headers: i } = e;
    if (!t)
      return Promise.reject(new u.ErrorInfo("unable to send reaction; name not set and it is required", 40001, 400));
    if (this._connection.state !== "connected")
      return Promise.reject(new u.ErrorInfo("unable to send reaction; not connected to Ably", 4e4, 400));
    const c = {
      name: t,
      metadata: r ?? {}
    }, l = {
      name: Ee.Reaction,
      data: c,
      extras: {
        headers: i ?? {}
      }
    };
    return this._channel.publish($r(l));
  }
  /**
   * @inheritDoc
   */
  subscribe(e) {
    this._logger.trace("RoomReactions.subscribe();");
    const t = v(e);
    return this._emitter.on(t), {
      unsubscribe: () => {
        this._logger.trace("RoomReactions.unsubscribe();"), this._emitter.off(t);
      }
    };
  }
  /**
   * Disposes of the room reactions instance, removing all listeners and subscriptions.
   * This method should be called when the room is being released to ensure proper cleanup.
   * @internal
   */
  dispose() {
    this._unsubscribeRoomReactionEvents(), this._emitter.off();
  }
  /**
   * Checks if there are any listeners registered by users.
   * @internal
   * @returns true if there are listeners, false otherwise.
   */
  hasListeners() {
    return N(this._emitter);
  }
}
class Wr extends A {
  /**
   * Constructs a new `DefaultTyping` instance.
   * @param options The options for typing in the room.
   * @param connection The connection instance.
   * @param channel The channel for the room.
   * @param clientId The client ID of the user.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, r, i, c) {
    super(), this._timeoutMs = 2e3, this._mutex = new Pt(), this._internalSubscribeToEvents = (l) => {
      const { name: d, clientId: g } = l;
      if (this._logger.trace("DefaultTyping._internalSubscribeToEvents(); received event", {
        name: d,
        clientId: g
      }), !g) {
        this._logger.error("DefaultTyping._internalSubscribeToEvents(); invalid clientId in received event", {
          inbound: l
        });
        return;
      }
      d === T.Started || d === T.Stopped ? this._updateCurrentlyTyping(g, d) : this._logger.warn("DefaultTyping._internalSubscribeToEvents(); unrecognized event", {
        name: d
      });
    }, this._clientId = i, this._channel = r, this._connection = t, this._heartbeatThrottleMs = e.heartbeatThrottleMs, this._currentlyTyping = /* @__PURE__ */ new Map(), this._logger = c, this._unsubscribeTypingEvents = F(
      this._channel,
      [T.Started, T.Stopped],
      this._internalSubscribeToEvents.bind(this)
    );
  }
  /**
   * Clears all typing states.
   * This includes clearing all timeouts and the currently typing map.
   */
  _clearAllTypingStates() {
    this._logger.debug("DefaultTyping._clearAllTypingStates(); clearing all typing states"), this._clearHeartbeatTimer(), this._clearCurrentlyTyping();
  }
  /**
   * Clears the heartbeat timer.
   */
  _clearHeartbeatTimer() {
    this._logger.trace("DefaultTyping._clearHeartbeatTimer(); clearing heartbeat timer"), this._heartbeatTimerId && (clearTimeout(this._heartbeatTimerId), this._heartbeatTimerId = void 0);
  }
  /**
   * Clears the currently typing store and removes all timeouts for associated clients.
   */
  _clearCurrentlyTyping() {
    this._logger.trace("DefaultTyping._clearCurrentlyTyping(); clearing current store and timeouts");
    for (const [, e] of this._currentlyTyping.entries())
      clearTimeout(e);
    this._currentlyTyping.clear();
  }
  /**
   * CHA-T16
   * @inheritDoc
   */
  current() {
    return this._logger.trace("DefaultTyping.current();"), new Set(this._currentlyTyping.keys());
  }
  /**
   * @inheritDoc
   */
  get channel() {
    return this._channel;
  }
  /**
   * Start the heartbeat timer. This will expire after the configured interval.
   */
  _startHeartbeatTimer() {
    if (!this._heartbeatTimerId) {
      this._logger.trace("DefaultTyping.startHeartbeatTimer();");
      const e = this._heartbeatTimerId = setTimeout(() => {
        this._logger.debug("DefaultTyping.startHeartbeatTimer(); heartbeat timer expired"), e === this._heartbeatTimerId && (this._heartbeatTimerId = void 0);
      }, this._heartbeatThrottleMs);
    }
  }
  /**
   * @inheritDoc
   */
  async keystroke() {
    this._logger.trace("DefaultTyping.keystroke();"), this._mutex.cancel();
    try {
      await this._mutex.acquire();
    } catch (e) {
      if (e === le) {
        this._logger.debug("DefaultTyping.keystroke(); mutex was canceled by a later operation");
        return;
      }
      throw new u.ErrorInfo("mutex acquisition failed", 5e4, 500);
    }
    try {
      if (this._connection.state !== "connected")
        throw this._logger.error("DefaultTyping.keystroke(); connection is not connected", {
          status: this._connection.state
        }), new u.ErrorInfo("cannot type, connection is not connected", 4e4, 400);
      if (this._heartbeatTimerId) {
        this._logger.debug("DefaultTyping.keystroke(); no-op, already typing and heartbeat timer has not expired");
        return;
      }
      await this._channel.publish(Mt(T.Started)), this._startHeartbeatTimer(), this._logger.trace("DefaultTyping.keystroke(); starting timers");
    } finally {
      this._logger.trace("DefaultTyping.keystroke(); releasing mutex"), this._mutex.release();
    }
  }
  /**
   * @inheritDoc
   */
  async stop() {
    this._logger.trace("DefaultTyping.stop();"), this._mutex.cancel();
    try {
      await this._mutex.acquire();
    } catch (e) {
      if (e === le) {
        this._logger.debug("DefaultTyping.stop(); mutex was canceled by a later operation");
        return;
      }
      throw new u.ErrorInfo("mutex acquisition failed", 5e4, 500);
    }
    try {
      if (this._connection.state !== "connected")
        throw this._logger.error("DefaultTyping.stop(); connection is not connected", {
          status: this._connection.state
        }), new u.ErrorInfo("cannot stop typing, connection is not connected", 4e4, 400);
      if (!this._heartbeatTimerId) {
        this._logger.debug("DefaultTyping.stop(); no-op, not currently typing");
        return;
      }
      await this._channel.publish(Mt(T.Stopped)), this._logger.trace("DefaultTyping.stop(); clearing timers"), clearTimeout(this._heartbeatTimerId), this._heartbeatTimerId = void 0;
    } finally {
      this._logger.trace("DefaultTyping.stop(); releasing mutex"), this._mutex.release();
    }
  }
  /**
   * @inheritDoc
   */
  subscribe(e) {
    this._logger.trace("DefaultTyping.subscribe();");
    const t = v(e);
    return this.on(t), {
      unsubscribe: () => {
        this._logger.trace("DefaultTyping.unsubscribe();"), this.off(t);
      }
    };
  }
  /**
   * @inheritDoc
   */
  // CHA-RL3h
  async dispose() {
    for (this._logger.trace("DefaultTyping.dispose();"); ; )
      try {
        this._mutex.cancel(), await this._mutex.acquire();
        break;
      } catch (e) {
        if (e === le)
          this._logger.debug("DefaultTyping.dispose(); mutex was canceled"), await new Promise((t) => setTimeout(t, 200)), this._logger.debug("DefaultTyping.dispose(); retrying mutex acquisition");
        else {
          this._logger.error("DefaultTyping.dispose(); failed to acquire mutex; could not complete resource disposal", {
            error: e
          });
          return;
        }
      }
    this._clearAllTypingStates(), this._unsubscribeTypingEvents(), this.off(), this._mutex.release();
  }
  /**
   * Update the currently typing users. This method is called when a typing event is received.
   * It will also acquire a mutex to ensure that the currentlyTyping state is updated safely.
   * @param clientId The client ID of the user.
   * @param event The typing event.
   */
  _updateCurrentlyTyping(e, t) {
    this._logger.trace("DefaultTyping._updateCurrentlyTyping();", { clientId: e, event: t }), t === T.Started ? this._handleTypingStart(e) : this._handleTypingStop(e);
  }
  /**
   * Starts a new inactivity timer for the client.
   * This timer will expire after the configured timeout,
   * which is the sum of the heartbeat interval and the inactivity timeout.
   * @param clientId The client ID for which to start the timer.
   * @returns The timeout ID for the new timer.
   */
  _startNewClientInactivityTimer(e) {
    this._logger.trace("DefaultTyping._startNewClientInactivityTimer(); starting new inactivity timer", {
      clientId: e
    });
    const t = setTimeout(() => {
      if (this._logger.trace("DefaultTyping._startNewClientInactivityTimer(); client typing timeout expired", {
        clientId: e
      }), this._currentlyTyping.get(e) !== t) {
        this._logger.debug("DefaultTyping._startNewClientInactivityTimer(); timeout already cleared; ignoring", {
          clientId: e
        });
        return;
      }
      this._currentlyTyping.delete(e), this.emit(k.SetChanged, {
        type: k.SetChanged,
        currentlyTyping: new Set(this._currentlyTyping.keys()),
        change: {
          clientId: e,
          type: T.Stopped
        }
      });
    }, this._heartbeatThrottleMs + this._timeoutMs);
    return t;
  }
  /**
   * Handles logic for TypingEventType.Started, including starting a new timeout or resetting an existing one.
   * @param clientId The client ID that started typing.
   */
  _handleTypingStart(e) {
    this._logger.debug("DefaultTyping._handleTypingStart();", { clientId: e });
    const t = this._startNewClientInactivityTimer(e), r = this._currentlyTyping.get(e);
    this._currentlyTyping.set(e, t), r ? (this._logger.debug("DefaultTyping._handleTypingStart(); received heartbeat for currently typing client", {
      clientId: e
    }), clearTimeout(r)) : (this._logger.debug("DefaultTyping._handleTypingStart(); new client started typing", {
      clientId: e
    }), this.emit(k.SetChanged, {
      type: k.SetChanged,
      currentlyTyping: new Set(this._currentlyTyping.keys()),
      change: {
        clientId: e,
        type: T.Started
      }
    }));
  }
  /**
   * Handles logic for TypingEventType.Stopped, including clearing the timeout for the client.
   * @param clientId The client ID that stopped typing.
   */
  _handleTypingStop(e) {
    const t = this._currentlyTyping.get(e);
    if (!t) {
      this._logger.trace(
        'DefaultTyping._handleTypingStop(); received "Stop" event for client not in currentlyTyping list',
        { clientId: e }
      );
      return;
    }
    this._logger.debug("DefaultTyping._handleTypingStop(); client stopped typing", { clientId: e }), clearTimeout(t), this._currentlyTyping.delete(e), this.emit(k.SetChanged, {
      type: k.SetChanged,
      currentlyTyping: new Set(this._currentlyTyping.keys()),
      change: {
        clientId: e,
        type: T.Stopped
      }
    });
  }
  get heartbeatThrottleMs() {
    return this._heartbeatThrottleMs;
  }
  get hasHeartbeatTimer() {
    return !!this._heartbeatTimerId;
  }
}
class Kr {
  /**
   * Constructs a new Room instance.
   * @param name The unique identifier of the room.
   * @param nonce A random identifier for the room instance, useful in debugging and logging.
   * @param options The options for the room.
   * @param realtime An instance of the Ably Realtime client.
   * @param chatApi An instance of the ChatApi.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, r, i, c, l) {
    Ur(r), this._nonce = t, this._logger = l.withContext({ roomName: e, roomNonce: t }), this._logger.debug("Room();", { options: r }), this._name = e, this._options = r, this._chatApi = c, this._lifecycle = new Lr(this._logger);
    const d = this._channelManager = this._getChannelManager(r, i, this._logger), g = d.get();
    this._messages = new Sr(
      e,
      r.messages,
      g,
      this._chatApi,
      i.auth.clientId,
      this._logger
    ), this._presence = new Tt(g, i.auth.clientId, this._logger, r), this._typing = new Wr(
      r.typing,
      i.connection,
      g,
      i.auth.clientId,
      this._logger
    ), this._reactions = new Gr(g, i.connection, i.auth.clientId, this._logger), this._occupancy = new Rt(e, g, this._chatApi, this._logger, r), this._lifecycleManager = new Pr(d, this._lifecycle, this._logger);
    let m = !1;
    this._finalizer = async () => {
      if (m) {
        this._logger.debug("Room.finalizer(); already finalized");
        return;
      }
      await this._lifecycleManager.release(), this._lifecycleManager.dispose(), this._messages.dispose(), this._presence.dispose(), this._reactions.dispose(), this._occupancy.dispose(), await this._typing.dispose(), this._lifecycle.dispose(), m = !0;
    };
  }
  /**
   * Gets the channel manager for the room, which handles merging channel options together and creating channels.
   * @param options The room options.
   * @param realtime  An instance of the Ably Realtime client.
   * @param logger An instance of the Logger.
   * @returns The channel manager instance.
   */
  _getChannelManager(e, t, r) {
    const i = new Er(this._name, t, r, e.isReactClient);
    return i.mergeOptions(Rt.channelOptionMerger(e)), i.mergeOptions(Tt.channelOptionMerger(e)), i.mergeOptions(It.channelOptionMerger(e)), i;
  }
  /**
   * @inheritdoc
   */
  get name() {
    return this._name;
  }
  /**
   * @inheritDoc
   */
  options() {
    return D(this._options);
  }
  /**
   * @inheritdoc
   */
  get messages() {
    return this._messages;
  }
  /**
   * @inheritdoc
   */
  get presence() {
    return this._presence;
  }
  /**
   * @inheritdoc
   */
  get reactions() {
    return this._reactions;
  }
  /**
   * @inheritdoc
   */
  get typing() {
    return this._typing;
  }
  /**
   * @inheritdoc
   */
  get occupancy() {
    return this._occupancy;
  }
  /**
   * @inheritdoc
   */
  get status() {
    return this._lifecycle.status;
  }
  /**
   * @inheritdoc
   */
  get error() {
    return this._lifecycle.error;
  }
  /**
   * @inheritdoc
   */
  onStatusChange(e) {
    return this._lifecycle.onChange(e);
  }
  /**
   * @inheritdoc
   */
  async attach() {
    return this._logger.trace("Room.attach();"), this._lifecycleManager.attach();
  }
  /**
   * @inheritdoc
   */
  async detach() {
    return this._logger.trace("Room.detach();"), this._lifecycleManager.detach();
  }
  /**
   * Releases resources associated with the room.
   * @returns A promise that resolves when the room is released.
   */
  release() {
    return this._logger.trace("Room.release();"), this._finalizer();
  }
  /**
   * A random identifier for the room instance, useful in debugging and logging.
   * @returns The nonce.
   */
  get nonce() {
    return this._nonce;
  }
  /**
   * @internal
   * @returns The internal room lifecycle.
   */
  get lifecycle() {
    return this._lifecycle;
  }
  /**
   * @internal
   * @returns The room lifecycle manager.
   */
  get lifecycleManager() {
    return this._lifecycleManager;
  }
  /**
   * @inheritdoc
   */
  onDiscontinuity(e) {
    return this._logger.trace("Room.onDiscontinuity();"), this._lifecycleManager.onDiscontinuity(e);
  }
  /**
   * @inheritdoc
   */
  get channel() {
    return this._channelManager.get();
  }
}
class Qr {
  /**
   * Constructs a new Rooms instance.
   * @param realtime An instance of the Ably Realtime client.
   * @param clientOptions The client options from the chat instance.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, r) {
    this._rooms = /* @__PURE__ */ new Map(), this._releasing = /* @__PURE__ */ new Map(), this._isReact = !1, this._disposed = !1, this._realtime = e, this._chatApi = new vr(e, r), this._clientOptions = t, this._logger = r;
  }
  /**
   * @inheritDoc
   */
  async get(e, t) {
    this._logger.trace("Rooms.get();", { roomName: e }), this._ensureNotDisposed();
    const r = this._rooms.get(e);
    if (r)
      return this._handleExistingRoom(r, e, t);
    const i = this._releasing.get(e), c = Et();
    return i ? this._waitForReleaseAndCreateRoom(e, c, t, i) : this._createNewRoom(e, c, t);
  }
  /**
   * @inheritDoc
   */
  async release(e) {
    this._logger.trace("Rooms.release();", { roomName: e });
    const t = this._rooms.get(e), r = this._releasing.get(e);
    return t ? r ? this._handleConcurrentRelease(e, t, r) : this._performRoomRelease(e, t) : this._handleNonExistentRoomRelease(e, r);
  }
  /**
   * Disposes all rooms that are currently in the rooms map and waits for any ongoing release operations to complete.
   * This method releases all rooms concurrently, waits for any in-flight releases to finish, and clears the rooms map.
   * After this method resolves, all rooms will have been fully released and cleaned up.
   * @internal
   * @returns A promise that resolves when all rooms have been released.
   */
  async dispose() {
    this._logger.trace("Rooms.dispose();"), this._disposed = !0;
    const e = [...this._rooms.keys()];
    if (e.length === 0) {
      this._logger.debug("Rooms.dispose(); no rooms to release");
      return;
    }
    const t = e.map((c) => this.release(c)), r = [...this._releasing.values()], i = [...t, ...r];
    this._logger.debug("Rooms.dispose(); releasing rooms", { roomCount: e.length, roomNames: e }), await Promise.all(i), this._logger.debug("Rooms.dispose(); all rooms released successfully");
  }
  /**
   * Get the client options used to create the Chat instance.
   * @returns ChatClientOptions
   */
  get clientOptions() {
    return this._clientOptions;
  }
  /**
   * @inheritDoc
   */
  get count() {
    return this._rooms.size;
  }
  /**
   * Ensures the rooms instance has not been disposed.
   */
  _ensureNotDisposed() {
    if (this._disposed)
      throw new u.ErrorInfo("cannot get room, rooms instance has been disposed", 4e4, 400);
  }
  /**
   * Handles the case where a room already exists.
   * @param existingRoom The existing room entry in the map.
   * @param name The unique identifier of the room.
   * @param options The options for the room.
   * @returns A promise that resolves to the existing room.
   */
  async _handleExistingRoom(e, t, r) {
    if (!Y(e.options, r))
      throw new u.ErrorInfo("room already exists with different options", 4e4, 400);
    return this._logger.debug("Rooms.get(); returning existing room", {
      roomName: t,
      nonce: e.nonce,
      options: r
    }), await e.promise;
  }
  /**
   * Creates a new room when no existing room or ongoing release exists.
   * @param name The unique identifier of the room.
   * @param nonce A random, internal identifier useful for debugging and logging.
   * @param options The options for the room.
   * @returns A new room object.
   */
  _createNewRoom(e, t, r) {
    const i = this._makeRoom(e, t, r), c = {
      promise: Promise.resolve(i),
      nonce: t,
      options: r
    };
    return this._rooms.set(e, c), this._logger.debug("Rooms.get(); returning new room", { roomName: e, nonce: i.nonce }), i;
  }
  /**
   * Waits for an ongoing release to complete, then creates a new room.
   * @param name The unique identifier of the room.
   * @param nonce A random, internal identifier useful for debugging and logging.
   * @param options The options for the room.
   * @param ongoingRelease The promise of an ongoing release operation.
   * @returns A promise that resolves to a room.
   */
  async _waitForReleaseAndCreateRoom(e, t, r, i) {
    const c = new AbortController(), l = this._createAbortableRoomPromise(e, t, r, i, c);
    return this._rooms.set(e, {
      promise: l,
      options: r,
      nonce: t,
      abort: c
    }), this._logger.debug("Rooms.get(); creating new promise dependent on previous release", { roomName: e }), await l;
  }
  /**
   * Creates a promise that can be aborted if the room is released before completion.
   * @param name The unique identifier of the room.
   * @param nonce A random, internal identifier useful for debugging and logging.
   * @param options The options for the room.
   * @param ongoingRelease A promise that resolves when the previous release operation is complete.
   * @param abortController An AbortController to manage the abort signal.
   * @returns A promise that resolves to a new room or rejects if the operation is aborted.
   */
  _createAbortableRoomPromise(e, t, r, i, c) {
    return new Promise((l, d) => {
      const g = () => {
        this._logger.debug("Rooms.get(); aborted before init", { roomName: e }), d(
          new u.ErrorInfo(
            "room released before get operation could complete",
            B.RoomReleasedBeforeOperationCompleted,
            400
          )
        );
      };
      c.signal.addEventListener("abort", g), i.then(() => {
        if (c.signal.aborted) {
          this._logger.debug("Rooms.get(); aborted before releasing promise resolved", { roomName: e });
          return;
        }
        this._logger.debug("Rooms.get(); releasing finished", { roomName: e });
        const m = this._makeRoom(e, t, r);
        c.signal.removeEventListener("abort", g), l(m);
      }).catch((m) => {
        c.signal.removeEventListener("abort", g), d(m);
      });
    });
  }
  /**
   * Handles release when no room exists.
   * @param name The unique identifier of the room.
   * @param ongoingRelease An ongoing release promise, if any.
   * @returns A promise that resolves when the release operation is complete.
   */
  async _handleNonExistentRoomRelease(e, t) {
    if (t) {
      this._logger.debug("Rooms.release(); waiting for previous release call", { roomName: e }), await t;
      return;
    }
    this._logger.debug("Rooms.release(); room does not exist", { roomName: e });
  }
  /**
   * Handles release when there's already a release in progress.
   * @param name The unique identifier of the room.
   * @param existingRoom The existing room entry in the map.
   * @param ongoingRelease The promise of an ongoing release operation.
   */
  async _handleConcurrentRelease(e, t, r) {
    t.abort && (this._logger.debug("Rooms.release(); aborting get call", {
      roomName: e,
      existingNonce: t.nonce
    }), t.abort.abort(), this._rooms.delete(e)), await r;
  }
  /**
   * Performs the actual room release operation.
   * @param name The unique identifier of the room.
   * @param existingRoom The existing room entry in the map.
   */
  async _performRoomRelease(e, t) {
    this._rooms.delete(e);
    const r = this._executeRoomRelease(e, t);
    this._releasing.set(e, r), this._logger.debug("Rooms.release(); creating new release promise", {
      roomName: e,
      nonce: t.nonce
    }), await r;
  }
  /**
   * Executes the room release and cleanup.
   * @param name The unique identifier of the room.
   * @param existingRoom The existing room entry in the map.
   */
  async _executeRoomRelease(e, t) {
    const r = await t.promise;
    this._logger.debug("Rooms.release(); releasing room", { roomName: e, nonce: t.nonce }), await r.release(), this._logger.debug("Rooms.release(); room released", { roomName: e, nonce: t.nonce }), this._releasing.delete(e);
  }
  /**
   * makes a new room object
   * @param name The unique identifier of the room.
   * @param nonce A random, internal identifier useful for debugging and logging.
   * @param options The options for the room.
   * @returns DefaultRoom A new room object.
   */
  _makeRoom(e, t, r) {
    return new Kr(
      e,
      t,
      Fr(r, this._isReact),
      this._realtime,
      this._chatApi,
      this._logger
    );
  }
  /**
   * Sets react JS mode.
   */
  useReact() {
    this._logger.trace("Rooms.useReact();"), this._isReact = !0;
  }
}
class Xr {
  /**
   * Constructor for Chat
   *
   * **Important**: The Ably Realtime client must have a clientId set. This can be done by configuring
   * token-based authentication that returns a token with a clientId, or by setting
   * the clientId directly in the Realtime client options.
   * @example
   * ```typescript
   * import * as Ably from 'ably';
   * import { ChatClient } from '@ably/chat';
   *
   * // Preferred in production: Use auth URL that returns a token with clientId
   * const realtime = new Ably.Realtime({
   *   authUrl: '/api/ably-auth', // Your server endpoint that returns an Ably token with clientId
   *   authMethod: 'POST'
   * });
   * const chatClient = new ChatClient(realtime);
   *
   * // Alternative for development and server-side operations: Set clientId directly (requires API key)
   * const realtime = new Ably.Realtime({
   *   key: 'your-ably-api-key',
   *   clientId: 'user-123'
   * });
   * const chatClient = new ChatClient(realtime);
   * ```
   * @param realtime - The Ably Realtime client.
   * @param clientOptions - The client options.
   */
  constructor(e, t) {
    this._realtime = e, this._clientOptions = cr(t), this._nonce = Et(), this._logger = ar(this._clientOptions).withContext({
      chatClientNonce: this._nonce
    }), this._connection = new gr(e, this._logger), this._rooms = new Qr(e, this._clientOptions, this._logger), this._addAgent("chat-js"), this._logger.trace(`ably chat client version ${ge}; initialized`);
  }
  /**
   * Returns the rooms object, which provides access to chat rooms.
   * @returns The rooms object.
   */
  get rooms() {
    return this._rooms;
  }
  /**
   * Returns the underlying connection to Ably, which can be used to monitor the client's
   * connection to Ably servers.
   * @returns The connection object.
   */
  get connection() {
    return this._connection;
  }
  /**
   * Returns the clientId of the current client.
   * @returns The clientId.
   */
  get clientId() {
    return this._realtime.auth.clientId;
  }
  /**
   * Returns the underlying Ably Realtime client.
   * @returns The Ably Realtime client.
   */
  get realtime() {
    return this._realtime;
  }
  /**
   * Returns the resolved client options for the client, including any defaults that have been set.
   * @returns The client options.
   */
  get clientOptions() {
    return this._clientOptions;
  }
  /**
   * Returns the logger instance for the client.
   * @internal
   * @returns The logger instance.
   */
  get logger() {
    return this._logger;
  }
  /**
   * Adds additional agent information to the client.
   * Used internally to add React-specific agent information.
   * @internal
   */
  addReactAgent() {
    this._addAgent("chat-react"), this._rooms.useReact();
  }
  /**
   * Adds additional agent information to the client.
   * This is used internally to add a specific agent with a version.
   * @param agent - The agent to add.
   * @param version - The version of the agent, defaults to the current client version.
   * @internal
   */
  addAgentWithVersion(e, t) {
    this._addAgent(e, t), this._logger.trace(`Added agent ${e} with version ${t}`);
  }
  /**
   * Disposes of the ChatClient instance, cleaning up any resources and rendering it unusable.
   * This method will release all rooms before disposing of the client.
   */
  async dispose() {
    this._logger.trace("ChatClient.dispose();"), await this._rooms.dispose(), this._connection.dispose(), this._logger.debug("ChatClient.dispose(); client disposed successfully");
  }
  /**
   * Sets the agent string for the client.
   * @param agent - The agent to add.
   * @param version - The version of the agent, defaults to the current client version.
   * @internal
   */
  _addAgent(e, t) {
    const r = this._realtime;
    r.options.agents = { ...r.options.agents ?? r.options.agents, [e]: t ?? ge };
  }
}
export {
  Xr as ChatClient,
  R as ChatMessageAction,
  P as ChatMessageEventType,
  ur as ConnectionStatus,
  B as ErrorCode,
  At as LogLevel,
  M as MessageReactionEventType,
  z as MessageReactionType,
  Oe as OccupancyEventType,
  Ie as OrderBy,
  dr as PresenceEventType,
  J as RoomEventType,
  f as RoomStatus,
  T as TypingEventType,
  k as TypingSetEventType,
  Jr as errorInfoIs
};
//# sourceMappingURL=ably-chat.js.map
